var Jt = (i) => {
  throw TypeError(i);
};
var He = (i, a, y) => a.has(i) || Jt("Cannot " + y);
var T = (i, a, y) => (He(i, a, "read from private field"), y ? y.call(i) : a.get(i)), se = (i, a, y) => a.has(i) ? Jt("Cannot add the same private member more than once") : a instanceof WeakSet ? a.add(i) : a.set(i, y), $ = (i, a, y, v) => (He(i, a, "write to private field"), v ? v.call(i, y) : a.set(i, y), y), ie = (i, a, y) => (He(i, a, "access private method"), y);
import { r as ne, e as Gt, g as Hr, j as X } from "./client-BkmPNNjT.mjs.js";
import { a as Ce, d as Wr } from "./button-T1HtNzbf.mjs.js";
import { c as Mr, X as Xr } from "./x-BeA-aqru.mjs.js";
import { S as Yr, p as Ht, r as pe, s as At, a as je, n as Ot, i as Tt, b as Wt, t as Zr, c as Qe, f as $r, d as ei, e as Xt, g as zr, h as ti, u as ri, k as zt } from "./layout-CEgW1KBl.mjs.js";
var le, Q, Be, ce, Se, Ae, be, me, Fe, Oe, Te, qe, Ee, ke, Ie, J, Le, It, Nt, Ut, Dt, Pt, Lt, jt, Qr, Fr, ii = (Fr = class extends Yr {
  constructor(a, y) {
    super();
    se(this, J);
    se(this, le);
    se(this, Q);
    se(this, Be);
    se(this, ce);
    se(this, Se);
    se(this, Ae);
    se(this, be);
    se(this, me);
    se(this, Fe);
    se(this, Oe);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    se(this, Te);
    se(this, qe);
    se(this, Ee);
    se(this, ke);
    se(this, Ie, /* @__PURE__ */ new Set());
    this.options = y, $(this, le, a), $(this, me, null), $(this, be, Ht()), this.bindMethods(), this.setOptions(y);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (T(this, Q).addObserver(this), Yt(T(this, Q), this.options) ? ie(this, J, Le).call(this) : this.updateResult(), ie(this, J, Dt).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Bt(
      T(this, Q),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Bt(
      T(this, Q),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), ie(this, J, Pt).call(this), ie(this, J, Lt).call(this), T(this, Q).removeObserver(this);
  }
  setOptions(a) {
    const y = this.options, v = T(this, Q);
    if (this.options = T(this, le).defaultQueryOptions(a), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof pe(this.options.enabled, T(this, Q)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    ie(this, J, jt).call(this), T(this, Q).setOptions(this.options), y._defaulted && !At(this.options, y) && T(this, le).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: T(this, Q),
      observer: this
    });
    const _ = this.hasListeners();
    _ && Zt(
      T(this, Q),
      v,
      this.options,
      y
    ) && ie(this, J, Le).call(this), this.updateResult(), _ && (T(this, Q) !== v || pe(this.options.enabled, T(this, Q)) !== pe(y.enabled, T(this, Q)) || je(this.options.staleTime, T(this, Q)) !== je(y.staleTime, T(this, Q))) && ie(this, J, It).call(this);
    const h = ie(this, J, Nt).call(this);
    _ && (T(this, Q) !== v || pe(this.options.enabled, T(this, Q)) !== pe(y.enabled, T(this, Q)) || h !== T(this, ke)) && ie(this, J, Ut).call(this, h);
  }
  getOptimisticResult(a) {
    const y = T(this, le).getQueryCache().build(T(this, le), a), v = this.createResult(y, a);
    return oi(this, v) && ($(this, ce, v), $(this, Ae, this.options), $(this, Se, T(this, Q).state)), v;
  }
  getCurrentResult() {
    return T(this, ce);
  }
  trackResult(a, y) {
    return new Proxy(a, {
      get: (v, _) => (this.trackProp(_), y?.(_), _ === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && T(this, be).status === "pending" && T(this, be).reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      )), Reflect.get(v, _))
    });
  }
  trackProp(a) {
    T(this, Ie).add(a);
  }
  getCurrentQuery() {
    return T(this, Q);
  }
  refetch({ ...a } = {}) {
    return this.fetch({
      ...a
    });
  }
  fetchOptimistic(a) {
    const y = T(this, le).defaultQueryOptions(a), v = T(this, le).getQueryCache().build(T(this, le), y);
    return v.fetch().then(() => this.createResult(v, y));
  }
  fetch(a) {
    return ie(this, J, Le).call(this, {
      ...a,
      cancelRefetch: a.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), T(this, ce)));
  }
  createResult(a, y) {
    const v = T(this, Q), _ = this.options, h = T(this, ce), u = T(this, Se), g = T(this, Ae), R = a !== v ? a.state : T(this, Be), { state: E } = a;
    let m = { ...E }, x = !1, C;
    if (y._optimisticResults) {
      const d = this.hasListeners(), c = !d && Yt(a, y), b = d && Zt(a, v, y, _);
      (c || b) && (m = {
        ...m,
        ...ei(E.data, a.options)
      }), y._optimisticResults === "isRestoring" && (m.fetchStatus = "idle");
    }
    let { error: q, errorUpdatedAt: p, status: e } = m;
    C = m.data;
    let t = !1;
    if (y.placeholderData !== void 0 && C === void 0 && e === "pending") {
      let d;
      h?.isPlaceholderData && y.placeholderData === g?.placeholderData ? (d = h.data, t = !0) : d = typeof y.placeholderData == "function" ? y.placeholderData(
        T(this, Te)?.state.data,
        T(this, Te)
      ) : y.placeholderData, d !== void 0 && (e = "success", C = Xt(
        h?.data,
        d,
        y
      ), x = !0);
    }
    if (y.select && C !== void 0 && !t)
      if (h && C === u?.data && y.select === T(this, Fe))
        C = T(this, Oe);
      else
        try {
          $(this, Fe, y.select), C = y.select(C), C = Xt(h?.data, C, y), $(this, Oe, C), $(this, me, null);
        } catch (d) {
          $(this, me, d);
        }
    T(this, me) && (q = T(this, me), C = T(this, Oe), p = Date.now(), e = "error");
    const w = m.fetchStatus === "fetching", n = e === "pending", f = e === "error", S = n && w, l = C !== void 0, r = {
      status: e,
      fetchStatus: m.fetchStatus,
      isPending: n,
      isSuccess: e === "success",
      isError: f,
      isInitialLoading: S,
      isLoading: S,
      data: C,
      dataUpdatedAt: m.dataUpdatedAt,
      error: q,
      errorUpdatedAt: p,
      failureCount: m.fetchFailureCount,
      failureReason: m.fetchFailureReason,
      errorUpdateCount: m.errorUpdateCount,
      isFetched: m.dataUpdateCount > 0 || m.errorUpdateCount > 0,
      isFetchedAfterMount: m.dataUpdateCount > R.dataUpdateCount || m.errorUpdateCount > R.errorUpdateCount,
      isFetching: w,
      isRefetching: w && !n,
      isLoadingError: f && !l,
      isPaused: m.fetchStatus === "paused",
      isPlaceholderData: x,
      isRefetchError: f && l,
      isStale: Qt(a, y),
      refetch: this.refetch,
      promise: T(this, be),
      isEnabled: pe(y.enabled, a) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const d = (k) => {
        r.status === "error" ? k.reject(r.error) : r.data !== void 0 && k.resolve(r.data);
      }, c = () => {
        const k = $(this, be, r.promise = Ht());
        d(k);
      }, b = T(this, be);
      switch (b.status) {
        case "pending":
          a.queryHash === v.queryHash && d(b);
          break;
        case "fulfilled":
          (r.status === "error" || r.data !== b.value) && c();
          break;
        case "rejected":
          (r.status !== "error" || r.error !== b.reason) && c();
          break;
      }
    }
    return r;
  }
  updateResult() {
    const a = T(this, ce), y = this.createResult(T(this, Q), this.options);
    if ($(this, Se, T(this, Q).state), $(this, Ae, this.options), T(this, Se).data !== void 0 && $(this, Te, T(this, Q)), At(y, a))
      return;
    $(this, ce, y);
    const v = () => {
      if (!a)
        return !0;
      const { notifyOnChangeProps: _ } = this.options, h = typeof _ == "function" ? _() : _;
      if (h === "all" || !h && !T(this, Ie).size)
        return !0;
      const u = new Set(
        h ?? T(this, Ie)
      );
      return this.options.throwOnError && u.add("error"), Object.keys(T(this, ce)).some((g) => {
        const s = g;
        return T(this, ce)[s] !== a[s] && u.has(s);
      });
    };
    ie(this, J, Qr).call(this, { listeners: v() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && ie(this, J, Dt).call(this);
  }
}, le = new WeakMap(), Q = new WeakMap(), Be = new WeakMap(), ce = new WeakMap(), Se = new WeakMap(), Ae = new WeakMap(), be = new WeakMap(), me = new WeakMap(), Fe = new WeakMap(), Oe = new WeakMap(), Te = new WeakMap(), qe = new WeakMap(), Ee = new WeakMap(), ke = new WeakMap(), Ie = new WeakMap(), J = new WeakSet(), Le = function(a) {
  ie(this, J, jt).call(this);
  let y = T(this, Q).fetch(
    this.options,
    a
  );
  return a?.throwOnError || (y = y.catch(Ot)), y;
}, It = function() {
  ie(this, J, Pt).call(this);
  const a = je(
    this.options.staleTime,
    T(this, Q)
  );
  if (Tt || T(this, ce).isStale || !Wt(a))
    return;
  const v = Zr(T(this, ce).dataUpdatedAt, a) + 1;
  $(this, qe, Qe.setTimeout(() => {
    T(this, ce).isStale || this.updateResult();
  }, v));
}, Nt = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(T(this, Q)) : this.options.refetchInterval) ?? !1;
}, Ut = function(a) {
  ie(this, J, Lt).call(this), $(this, ke, a), !(Tt || pe(this.options.enabled, T(this, Q)) === !1 || !Wt(T(this, ke)) || T(this, ke) === 0) && $(this, Ee, Qe.setInterval(() => {
    (this.options.refetchIntervalInBackground || $r.isFocused()) && ie(this, J, Le).call(this);
  }, T(this, ke)));
}, Dt = function() {
  ie(this, J, It).call(this), ie(this, J, Ut).call(this, ie(this, J, Nt).call(this));
}, Pt = function() {
  T(this, qe) && (Qe.clearTimeout(T(this, qe)), $(this, qe, void 0));
}, Lt = function() {
  T(this, Ee) && (Qe.clearInterval(T(this, Ee)), $(this, Ee, void 0));
}, jt = function() {
  const a = T(this, le).getQueryCache().build(T(this, le), this.options);
  if (a === T(this, Q))
    return;
  const y = T(this, Q);
  $(this, Q, a), $(this, Be, a.state), this.hasListeners() && (y?.removeObserver(this), a.addObserver(this));
}, Qr = function(a) {
  zr.batch(() => {
    a.listeners && this.listeners.forEach((y) => {
      y(T(this, ce));
    }), T(this, le).getQueryCache().notify({
      query: T(this, Q),
      type: "observerResultsUpdated"
    });
  });
}, Fr);
function ni(i, a) {
  return pe(a.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && a.retryOnMount === !1);
}
function Yt(i, a) {
  return ni(i, a) || i.state.data !== void 0 && Bt(i, a, a.refetchOnMount);
}
function Bt(i, a, y) {
  if (pe(a.enabled, i) !== !1 && je(a.staleTime, i) !== "static") {
    const v = typeof y == "function" ? y(i) : y;
    return v === "always" || v !== !1 && Qt(i, a);
  }
  return !1;
}
function Zt(i, a, y, v) {
  return (i !== a || pe(v.enabled, i) === !1) && (!y.suspense || i.state.status !== "error") && Qt(i, y);
}
function Qt(i, a) {
  return pe(a.enabled, i) !== !1 && i.isStaleByTime(je(a.staleTime, i));
}
function oi(i, a) {
  return !At(i.getCurrentResult(), a);
}
var Vr = ne.createContext(!1), si = () => ne.useContext(Vr);
Vr.Provider;
function ai() {
  let i = !1;
  return {
    clearReset: () => {
      i = !1;
    },
    reset: () => {
      i = !0;
    },
    isReset: () => i
  };
}
var ui = ne.createContext(ai()), ci = () => ne.useContext(ui), li = (i, a) => {
  (i.suspense || i.throwOnError || i.experimental_prefetchInRender) && (a.isReset() || (i.retryOnMount = !1));
}, fi = (i) => {
  ne.useEffect(() => {
    i.clearReset();
  }, [i]);
}, di = ({
  result: i,
  errorResetBoundary: a,
  throwOnError: y,
  query: v,
  suspense: _
}) => i.isError && !a.isReset() && !i.isFetching && v && (_ && i.data === void 0 || ti(y, [i.error, v])), vi = (i) => {
  if (i.suspense) {
    const y = (_) => _ === "static" ? _ : Math.max(_ ?? 1e3, 1e3), v = i.staleTime;
    i.staleTime = typeof v == "function" ? (..._) => y(v(..._)) : y(v), typeof i.gcTime == "number" && (i.gcTime = Math.max(
      i.gcTime,
      1e3
    ));
  }
}, hi = (i, a) => i.isLoading && i.isFetching && !a, gi = (i, a) => i?.suspense && a.isPending, $t = (i, a, y) => a.fetchOptimistic(i).catch(() => {
  y.clearReset();
});
function _i(i, a, y) {
  const v = si(), _ = ci(), h = ri(), u = h.defaultQueryOptions(i);
  h.getDefaultOptions().queries?._experimental_beforeQuery?.(
    u
  ), u._optimisticResults = v ? "isRestoring" : "optimistic", vi(u), li(u, _), fi(_);
  const g = !h.getQueryCache().get(u.queryHash), [s] = ne.useState(
    () => new a(
      h,
      u
    )
  ), R = s.getOptimisticResult(u), E = !v && i.subscribed !== !1;
  if (ne.useSyncExternalStore(
    ne.useCallback(
      (m) => {
        const x = E ? s.subscribe(zr.batchCalls(m)) : Ot;
        return s.updateResult(), x;
      },
      [s, E]
    ),
    () => s.getCurrentResult(),
    () => s.getCurrentResult()
  ), ne.useEffect(() => {
    s.setOptions(u);
  }, [u, s]), gi(u, R))
    throw $t(u, s, _);
  if (di({
    result: R,
    errorResetBoundary: _,
    throwOnError: u.throwOnError,
    query: h.getQueryCache().get(u.queryHash),
    suspense: u.suspense
  }))
    throw R.error;
  return h.getDefaultOptions().queries?._experimental_afterQuery?.(
    u,
    R
  ), u.experimental_prefetchInRender && !Tt && hi(R, v) && (g ? (
    // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
    $t(u, s, _)
  ) : (
    // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
    h.getQueryCache().get(u.queryHash)?.promise
  ))?.catch(Ot).finally(() => {
    s.updateResult();
  }), u.notifyOnChangeProps ? R : s.trackResult(R);
}
function Vt(i, a) {
  return _i(i, ii);
}
const pi = [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
], yi = Mr("star-half", pi);
const wi = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], er = Mr("star", wi);
var We = { exports: {} }, tr;
function fe() {
  return tr || (tr = 1, (function(i) {
    function a(y) {
      return y && y.__esModule ? y : {
        default: y
      };
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(We)), We.exports;
}
var Xe = { exports: {} }, rr;
function ge() {
  return rr || (rr = 1, (function(i) {
    function a(y, v) {
      if (!(y instanceof v)) throw new TypeError("Cannot call a class as a function");
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Xe)), Xe.exports;
}
var Ye = { exports: {} }, Ze = { exports: {} }, $e = { exports: {} }, ir;
function Re() {
  return ir || (ir = 1, (function(i) {
    function a(y) {
      "@babel/helpers - typeof";
      return i.exports = a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
        return typeof v;
      } : function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, a(y);
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })($e)), $e.exports;
}
var et = { exports: {} }, nr;
function bi() {
  return nr || (nr = 1, (function(i) {
    var a = Re().default;
    function y(v, _) {
      if (a(v) != "object" || !v) return v;
      var h = v[Symbol.toPrimitive];
      if (h !== void 0) {
        var u = h.call(v, _ || "default");
        if (a(u) != "object") return u;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (_ === "string" ? String : Number)(v);
    }
    i.exports = y, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(et)), et.exports;
}
var or;
function Kr() {
  return or || (or = 1, (function(i) {
    var a = Re().default, y = bi();
    function v(_) {
      var h = y(_, "string");
      return a(h) == "symbol" ? h : h + "";
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Ze)), Ze.exports;
}
var sr;
function _e() {
  return sr || (sr = 1, (function(i) {
    var a = Kr();
    function y(_, h) {
      for (var u = 0; u < h.length; u++) {
        var g = h[u];
        g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(_, a(g.key), g);
      }
    }
    function v(_, h, u) {
      return h && y(_.prototype, h), u && y(_, u), Object.defineProperty(_, "prototype", {
        writable: !1
      }), _;
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Ye)), Ye.exports;
}
function mi(i) {
  throw new Error('Could not dynamically require "' + i + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var tt = { exports: {} }, ar;
function ki() {
  return ar || (ar = 1, (function(i) {
    (function() {
      Object.assign || Object.defineProperty(Object, "assign", { enumerable: !1, configurable: !0, writable: !0, value: function(v) {
        if (v == null) throw new TypeError("Cannot convert first argument to object");
        for (var _ = Object(v), h = 1; h < arguments.length; h++) {
          var u = arguments[h];
          if (u != null) {
            u = Object(u);
            for (var g = Object.keys(Object(u)), s = 0, R = g.length; R > s; s++) {
              var E = g[s], m = Object.getOwnPropertyDescriptor(u, E);
              m !== void 0 && m.enumerable && (_[E] = u[E]);
            }
          }
        }
        return _;
      } });
      function a(v) {
        let _;
        try {
          _ = window[v];
          const h = "__storage_test__";
          return _.setItem(h, h), _.removeItem(h), !0;
        } catch (h) {
          return DOMException && h instanceof DOMException && (h.name === "QuotaExceededError" || h.name === "QUOTA_EXCEEDED_ERR" || h.name === "NS_ERROR_DOM_QUOTA_REACHED" || h.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || h.toString().indexOf("QuotaExceededError") !== -1) && _ && _.length !== 0;
        }
      }
      var y = function(v) {
        var _ = {
          user_agent: null,
          persist: !0,
          cookie_name_client_id: "ConstructorioID_client_id",
          cookie_name_session_id: "ConstructorioID_session_id",
          cookie_name_session_data: "ConstructorioID_session",
          cookie_domain: null,
          cookie_secure: null,
          // null, true
          cookie_samesite: null,
          // null, Lax, Strict
          cookie_days_to_live: 365,
          local_name_client_id: "_constructorio_search_client_id",
          local_name_session_id: "_constructorio_search_session_id",
          local_name_session_data: "_constructorio_search_session",
          on_node: typeof window > "u",
          session_is_new: null,
          new_to_beacon: null,
          client_id_storage_location: "cookie",
          session_id_storage_location: "local"
        };
        if (Object.assign(this, _, v), !this.client_id)
          if (!this.on_node && this.persist) {
            var h;
            this.client_id_storage_location === "cookie" && (h = this.get_cookie(this.cookie_name_client_id), h && (this.delete_cookie(this.cookie_name_client_id), this.set_cookie(this.cookie_name_client_id, h))), this.client_id_storage_location === "local" && (h = this.get_local_object(this.local_name_client_id)), this.client_id = h || this.generate_client_id();
          } else
            this.client_id = this.generate_client_id();
        this.session_id || (!this.on_node && this.persist ? this.session_id = this.generate_session_id() : this.session_id = 1), this.on_node || (this.user_agent = this.user_agent || window && window.navigator && window.navigator.userAgent);
      };
      y.prototype.set_cookie = function(v, _) {
        if (!this.on_node && this.persist) {
          var h = new Date(Date.now() + this.cookie_days_to_live * 24 * 60 * 60 * 1e3), u = v + "=" + _ + "; expires=" + h.toUTCString() + "; path=/";
          return this.cookie_domain && (u += "; domain=" + this.cookie_domain), this.cookie_secure && (u += "; secure"), this.cookie_samesite && (u += "; samesite=" + this.cookie_samesite), document.cookie = u, u;
        }
        return null;
      }, y.prototype.get_cookie = function(v) {
        for (var _ = v + "=", h = document.cookie.split(";"), u = 0; u < h.length; u++) {
          var g = h[u];
          try {
            for (var s = decodeURIComponent(g); s.charAt(0) === " "; )
              s = s.substring(1);
            if (s.indexOf(_) === 0)
              return s.substring(_.length, s.length);
          } catch {
          }
        }
      }, y.prototype.delete_cookie = function(v) {
        document.cookie = v + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      }, y.prototype.generate_client_id = function() {
        var v;
        if (!this.on_node) {
          var _ = this.get_cookie(this.cookie_name_client_id), h = this.get_local_object(this.local_name_client_id);
          this.client_id_storage_location === "cookie" && h && (v = h, this.set_cookie(this.cookie_name_client_id, v), this.delete_local_object(this.local_name_client_id)), this.client_id_storage_location === "local" && _ && (v = _, this.set_local_object(this.local_name_client_id, v), this.delete_cookie(this.cookie_name_client_id));
        }
        return v || (v = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(u) {
          var g = Math.random() * 16 | 0, s = u === "x" ? g : g & 3 | 8;
          return s.toString(16);
        }), this.client_id_storage_location === "cookie" && this.set_cookie(this.cookie_name_client_id, v), this.client_id_storage_location === "local" && this.set_local_object(this.local_name_client_id, v)), v;
      }, y.prototype.get_local_object = function(v) {
        var _, h = a("localStorage") && window && window.localStorage;
        if (h && typeof v == "string")
          try {
            _ = JSON.parse(h.getItem(v));
          } catch {
            _ = h.getItem(v);
          }
        return _;
      }, y.prototype.set_local_object = function(v, _) {
        var h = a("localStorage") && window && window.localStorage;
        if (h && typeof v == "string") {
          if (typeof _ == "object")
            try {
              h.setItem(v, JSON.stringify(_));
            } catch {
            }
          if (typeof _ == "string" || typeof _ == "number")
            try {
              h.setItem(v, _);
            } catch {
            }
        }
      }, y.prototype.delete_local_object = function(v) {
        var _ = a("localStorage") && window && window.localStorage;
        if (_ && typeof v == "string")
          try {
            _.removeItem(v);
          } catch {
          }
      }, y.prototype.generate_session_id = function() {
        var v = this.get_cookie(this.cookie_name_session_data), _ = this.get_local_object(this.local_name_session_data), h = Date.now(), u = 1e3 * 60 * 30, g;
        if (this.session_id_storage_location === "local" && (g = this.get_local_object(this.local_name_session_data), !g && v && (g = v, this.delete_cookie(this.cookie_name_session_data))), this.session_id_storage_location === "cookie") {
          g = this.get_cookie(this.cookie_name_session_data);
          try {
            g = JSON.parse(g);
          } catch {
          }
          !g && _ && (g = _, this.delete_local_object(this.local_name_session_data));
        }
        var s = 1, R = 1;
        g && typeof g == "object" && (R = parseInt(g.sessionId, 10) || 1, g.lastTime > h - u ? s = R : s = R + 1), this.session_id = s, this.session_is_new = !(g && R === s), g && g.newToBeacon && (this.new_to_beacon = !0);
        const E = {
          sessionId: s,
          lastTime: h
        };
        return this.session_is_new && (E.newToBeacon = !0), this.session_id_storage_location === "local" && (this.set_local_object(this.local_name_session_id, s), this.set_local_object(this.local_name_session_data, E)), this.session_id_storage_location === "cookie" && (this.cookie_domain && (this.delete_cookie(this.cookie_name_session_id), this.delete_cookie(this.cookie_name_session_data)), this.set_cookie(this.cookie_name_session_id, s), this.set_cookie(this.cookie_name_session_data, JSON.stringify(E))), s;
      }, typeof mi < "u" && (i.exports = y);
    })();
  })(tt)), tt.exports;
}
var rt = {};
var ur;
function Si() {
  return ur || (ur = 1, (function(i) {
    (function(a) {
      a(typeof DO_NOT_EXPORT_CRC > "u" ? i : {});
    })(function(a) {
      a.version = "1.2.2";
      function y() {
        for (var r = 0, d = new Array(256), c = 0; c != 256; ++c)
          r = c, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, d[c] = r;
        return typeof Int32Array < "u" ? new Int32Array(d) : d;
      }
      var v = y();
      function _(r) {
        var d = 0, c = 0, b = 0, k = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
        for (b = 0; b != 256; ++b) k[b] = r[b];
        for (b = 0; b != 256; ++b)
          for (c = r[b], d = 256 + b; d < 4096; d += 256) c = k[d] = c >>> 8 ^ r[c & 255];
        var A = [];
        for (b = 1; b != 16; ++b) A[b - 1] = typeof Int32Array < "u" ? k.subarray(b * 256, b * 256 + 256) : k.slice(b * 256, b * 256 + 256);
        return A;
      }
      var h = _(v), u = h[0], g = h[1], s = h[2], R = h[3], E = h[4], m = h[5], x = h[6], C = h[7], q = h[8], p = h[9], e = h[10], t = h[11], w = h[12], n = h[13], f = h[14];
      function S(r, d) {
        for (var c = d ^ -1, b = 0, k = r.length; b < k; ) c = c >>> 8 ^ v[(c ^ r.charCodeAt(b++)) & 255];
        return ~c;
      }
      function l(r, d) {
        for (var c = d ^ -1, b = r.length - 15, k = 0; k < b; ) c = f[r[k++] ^ c & 255] ^ n[r[k++] ^ c >> 8 & 255] ^ w[r[k++] ^ c >> 16 & 255] ^ t[r[k++] ^ c >>> 24] ^ e[r[k++]] ^ p[r[k++]] ^ q[r[k++]] ^ C[r[k++]] ^ x[r[k++]] ^ m[r[k++]] ^ E[r[k++]] ^ R[r[k++]] ^ s[r[k++]] ^ g[r[k++]] ^ u[r[k++]] ^ v[r[k++]];
        for (b += 15; k < b; ) c = c >>> 8 ^ v[(c ^ r[k++]) & 255];
        return ~c;
      }
      function o(r, d) {
        for (var c = d ^ -1, b = 0, k = r.length, A = 0, O = 0; b < k; )
          A = r.charCodeAt(b++), A < 128 ? c = c >>> 8 ^ v[(c ^ A) & 255] : A < 2048 ? (c = c >>> 8 ^ v[(c ^ (192 | A >> 6 & 31)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A & 63)) & 255]) : A >= 55296 && A < 57344 ? (A = (A & 1023) + 64, O = r.charCodeAt(b++) & 1023, c = c >>> 8 ^ v[(c ^ (240 | A >> 8 & 7)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A >> 2 & 63)) & 255], c = c >>> 8 ^ v[(c ^ (128 | O >> 6 & 15 | (A & 3) << 4)) & 255], c = c >>> 8 ^ v[(c ^ (128 | O & 63)) & 255]) : (c = c >>> 8 ^ v[(c ^ (224 | A >> 12 & 15)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A >> 6 & 63)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A & 63)) & 255]);
        return ~c;
      }
      a.table = v, a.bstr = S, a.buf = l, a.str = o;
    });
  })(rt)), rt;
}
var it, cr;
function Kt() {
  if (cr) return it;
  cr = 1;
  function i(_) {
    var h;
    try {
      h = window[_];
      var u = "__storage_test__";
      return h.setItem(u, u), h.removeItem(u), !0;
    } catch (g) {
      return typeof DOMException < "u" && g instanceof DOMException && (g.name === "QuotaExceededError" || g.name === "QUOTA_EXCEEDED_ERR" || g.name === "NS_ERROR_DOM_QUOTA_REACHED" || g.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || g.toString().indexOf("QuotaExceededError") !== -1) && h && h.length !== 0;
    }
  }
  var a = {
    overflow: {},
    get: function(h) {
      var u = this.overflow[h];
      if (u)
        return u;
      if (!i("sessionStorage"))
        return null;
      var g = sessionStorage.getItem(h);
      if (g)
        try {
          return JSON.parse(g);
        } catch {
          return g;
        }
      return null;
    },
    set: function(h, u) {
      try {
        sessionStorage.setItem(h, JSON.stringify(u));
      } catch {
        this.overflow[h] = u;
      }
    },
    remove: function(h) {
      var u;
      (u = this.overflow) !== null && u !== void 0 && u[h] && delete this.overflow[h], i("sessionStorage") && sessionStorage.removeItem(h);
    },
    key: function(h) {
      var u, g;
      if (!i("sessionStorage")) {
        var s;
        return (s = Object.keys(this.overflow)) === null || s === void 0 ? void 0 : s[h];
      }
      var R = (u = sessionStorage) === null || u === void 0 ? void 0 : u.key(h), E = ((g = sessionStorage) === null || g === void 0 ? void 0 : g.length) || 0;
      if (h >= E) {
        var m, x = h - E;
        return (m = Object.keys(this.overflow)) === null || m === void 0 ? void 0 : m[x];
      }
      return R;
    },
    length: function() {
      var h = Object.keys(this.overflow).length;
      return i("sessionStorage") ? sessionStorage.length + h : h;
    },
    clear: function() {
      this.overflow = {}, i("sessionStorage") && sessionStorage.clear();
    }
  }, y = {
    overflow: {},
    get: function(h) {
      var u = this.overflow[h];
      if (u)
        return u;
      if (!i("localStorage"))
        return null;
      var g = localStorage.getItem(h);
      if (g)
        try {
          return JSON.parse(g);
        } catch {
          return g;
        }
      return null;
    },
    set: function(h, u) {
      try {
        localStorage.setItem(h, JSON.stringify(u));
      } catch {
        this.overflow[h] = u;
      }
    },
    remove: function(h) {
      var u;
      (u = this.overflow) !== null && u !== void 0 && u[h] && delete this.overflow[h], i("localStorage") && localStorage.removeItem(h);
    },
    key: function(h) {
      var u, g;
      if (!i("localStorage")) {
        var s;
        return (s = Object.keys(this.overflow)) === null || s === void 0 ? void 0 : s[h];
      }
      var R = (u = localStorage) === null || u === void 0 ? void 0 : u.key(h), E = ((g = localStorage) === null || g === void 0 ? void 0 : g.length) || 0;
      if (h >= E) {
        var m, x = h - E;
        return (m = Object.keys(this.overflow)) === null || m === void 0 ? void 0 : m[x];
      }
      return R;
    },
    length: function() {
      var h = Object.keys(this.overflow).length;
      return i("localStorage") ? localStorage.length + h : h;
    },
    clear: function() {
      this.overflow = {}, i("localStorage") && localStorage.clear();
    }
  }, v = {
    local: y,
    session: a,
    canUseStorage: i
  };
  return it = v, it;
}
var nt, lr;
function he() {
  if (lr) return nt;
  lr = 1;
  var i = fe(), a = i(Re()), y = Si(), v = Kt(), _ = "_constructorio_purchase_order_ids", h = [
    {
      pattern: /[\w\-+\\.]+@([\w-]+\.)+[\w-]{2,4}/,
      replaceWith: "<email_omitted>"
    },
    {
      pattern: /^(?:\+\d{11,12}|\+\d{1,3}\s\d{3}\s\d{3}\s\d{3,4}|\(\d{3}\)\d{7}|\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\d{3}-\d{4}|\(\d{3}\)\s\d{3}-\d{4})$/,
      replaceWith: "<phone_omitted>"
    },
    {
      pattern: /^(?:4[0-9]{15}|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
      // Visa, Mastercard, Amex, Discover, JCB and Diners Club, regex source: https://www.regular-expressions.info/creditcard.html
      replaceWith: "<credit_omitted>"
    }
    // Add more PII REGEX
  ], u = {
    trimNonBreakingSpaces: function(s) {
      return s.replace(/\s/g, " ").trim();
    },
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
    encodeURIComponentRFC3986: function(s) {
      return encodeURIComponent(s).replace(/[!'()*]/g, function(R) {
        return "%".concat(R.charCodeAt(0).toString(16).toUpperCase());
      });
    },
    cleanParams: function(s) {
      var R = {};
      return Object.keys(s).forEach(function(E) {
        var m = s[E];
        typeof m == "string" ? R[E] = u.trimNonBreakingSpaces(m) : R[E] = m;
      }), R;
    },
    throwHttpErrorFromResponse: function(s, R) {
      return R.json().then(function(E) {
        throw s.message = E.message, s.status = R.status, s.statusText = R.statusText, s.url = R.url, s.headers = R.headers, s;
      });
    },
    canUseDOM: function() {
      return !!(typeof window < "u" && window.document && window.document.createElement);
    },
    addEventListener: function(s, R, E) {
      u.canUseDOM() && window.addEventListener(s, R, E);
    },
    removeEventListener: function(s, R, E) {
      u.canUseDOM() && window.removeEventListener(s, R, E);
    },
    getNavigator: function() {
      return u.canUseDOM() ? window.navigator : {
        userAgent: "",
        webdriver: !1
      };
    },
    isNil: function(s) {
      return s == null;
    },
    getWindowLocation: function() {
      return u.canUseDOM() ? window.location : {};
    },
    dispatchEvent: function(s) {
      u.canUseDOM() && window.dispatchEvent(s);
    },
    createCustomEvent: function(s, R) {
      if (u.canUseDOM())
        try {
          return new window.CustomEvent(s, {
            detail: R
          });
        } catch {
          var E = document.createEvent("CustomEvent");
          return E.initCustomEvent(s, !1, !1, R), E;
        }
      return null;
    },
    hasOrderIdRecord: function(s) {
      var R = s.orderId, E = s.apiKey, m = R;
      E && (m = "".concat(E, "-").concat(R));
      var x = y.str(m.toString()), C = v.local.get(_);
      return typeof C == "string" && (C = JSON.parse(C)), C && C.includes(x) ? !0 : null;
    },
    addOrderIdRecord: function(s) {
      var R = s.orderId, E = s.apiKey, m = R;
      E && (m = "".concat(E, "-").concat(R));
      var x = y.str(m.toString()), C = v.local.get(_);
      if (typeof C == "string" && (C = JSON.parse(C)), C) {
        if (C.includes(x))
          return;
        C.length >= 10 && (C = C.slice(-9)), C.push(x);
      } else
        C = [x];
      v.local.set(_, C);
    },
    // Abort network request based on supplied timeout interval (in milliseconds)
    // - method call parameter takes precedence over global options parameter
    applyNetworkTimeout: function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, m = s && s.networkParameters && s.networkParameters.timeout, x = R && R.timeout, C = x || m;
      typeof C == "number" && E && setTimeout(function() {
        return E.abort();
      }, C);
    },
    stringify: function(s, R, E) {
      if (!s)
        return "";
      var m = [];
      return Object.keys(s).forEach(function(x) {
        var C = s[x], q = u.encodeURIComponentRFC3986(x), p;
        if (C != null) {
          var e = R ? "".concat(R, "%5B").concat(q, "%5D") : q;
          Array.isArray(C) ? p = u.stringify(C, e, "array") : (0, a.default)(C) === "object" ? p = u.stringify(C, e, "object") : E === "object" ? p = "".concat(e, "=").concat(u.encodeURIComponentRFC3986(C)) : p = "".concat(R || q, "=").concat(u.encodeURIComponentRFC3986(C)), m.push(p);
        }
      }), m.join("&");
    },
    toSnakeCase: function(s) {
      return s.replace(/[A-Z]/g, function(R) {
        return "_".concat(R.toLowerCase());
      });
    },
    toSnakeCaseKeys: function(s) {
      var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, E = {};
      return Object.keys(s).forEach(function(m) {
        var x = u.toSnakeCase(m);
        E[x] = R && (0, a.default)(s[m]) === "object" && !Array.isArray(s[m]) ? u.toSnakeCaseKeys(s[m], R) : s[m];
      }), E;
    },
    containsPii: function(s, R) {
      var E = s.toLowerCase();
      return R.test(E);
    },
    obfuscatePiiRequest: function(s) {
      var R = s;
      try {
        var E, m, x = new URL(s), C = x == null || (E = x.pathname) === null || E === void 0 ? void 0 : E.split("/"), q = x == null || (m = x.search) === null || m === void 0 || (m = m.split("&")) === null || m === void 0 ? void 0 : m.map(function(p) {
          var e;
          return (e = p.split("=")) === null || e === void 0 ? void 0 : e[1];
        });
        h.forEach(function(p) {
          var e = p.pattern, t = p.replaceWith;
          C.forEach(function(w) {
            var n = decodeURIComponent(w);
            u.containsPii(n, e) && (R = R.replaceAll(w, t));
          }), q.forEach(function(w) {
            var n = decodeURIComponent(w);
            u.containsPii(n, e) && (R = R.replaceAll(n, t));
          });
        });
      } catch {
      }
      return R;
    },
    convertResponseToJson: function(s) {
      return s.ok ? s.json().catch(function() {
        return s.text().then(function(R) {
          throw new Error("Server responded with an invalid JSON object. Response code: ".concat(s.code, ", Response: ").concat(R));
        });
      }) : u.throwHttpErrorFromResponse(new Error(), s);
    },
    addHTTPSToString: function(s) {
      if (typeof s != "string")
        return null;
      var R = s.startsWith("https://"), E = s.startsWith("http://");
      if (!R && E)
        return s.replace("http", "https");
      if (!E && !R) {
        var m = "https://".concat(s);
        return m;
      }
      return s;
    },
    truncateString: function(s, R) {
      return s.slice(0, R);
    }
  };
  return nt = u, nt;
}
var ot, fr;
function Ne() {
  if (fr) return ot;
  fr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = he(), _ = /* @__PURE__ */ (function() {
    function h(u) {
      var g = this;
      (0, a.default)(this, h), this.events = [], this.enabled = !(u && u.enabled === !1), this.waitForBeacon = !(u && u.waitForBeacon === !1), this.active = this.enabled, this.waitForBeacon && (this.active = !1, v.canUseDOM() && (window.ConstructorioAutocomplete || window.ConstructorioBeacon || window.ConstructorioTracker) && this.enabled && (this.active = !0, this.dispatchEvents()), v.addEventListener("cio.beacon.loaded", function() {
        g.enabled && (g.active = !0, g.dispatchEvents());
      }));
    }
    return (0, y.default)(h, [{
      key: "queue",
      value: function(g, s) {
        this.events.push({
          name: g,
          data: s
        }), this.active && this.dispatchEvents();
      }
      // Dispatch all custom events within queue on `window` of supplied name with data
    }, {
      key: "dispatchEvents",
      value: function() {
        for (; this.events.length; ) {
          var g = this.events.shift(), s = g.name, R = g.data, E = "cio.client.".concat(s);
          v.dispatchEvent(v.createCustomEvent(E, R));
        }
      }
    }]);
  })();
  return ot = _, ot;
}
var st, dr;
function qi() {
  if (dr) return st;
  dr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = Ne(), _ = he();
  function h(g, s, R) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, m = R.apiKey, x = R.version, C = R.serviceUrl, q = R.sessionId, p = R.clientId, e = R.userId, t = R.segments, w = R.testCells, n = {
      c: x
    };
    if (n.key = m, n.i = p, n.s = q, !g || typeof g != "string")
      throw new Error("query is a required parameter of type string");
    if (w && Object.keys(w).forEach(function(D) {
      n["ef-".concat(D)] = w[D];
    }), t && t.length && (n.us = t), e && (n.ui = String(e)), s) {
      var f = s.offset, S = s.page, l = s.resultsPerPage, o = s.filters, r = s.sortBy, d = s.sortOrder, c = s.section, b = s.fmtOptions, k = s.hiddenFields, A = s.hiddenFacets, O = s.variationsMap, N = s.qsParam, U = s.preFilterExpression, I = s.filterMatchTypes;
      _.isNil(f) || (n.offset = f), _.isNil(S) || (n.page = S), _.isNil(l) || (n.num_results_per_page = l), o && (n.filters = o), I && (n.filter_match_types = I), r && (n.sort_by = r), d && (n.sort_order = d), c && (n.section = c), b && (n.fmt_options = b), k && (n.fmt_options ? n.fmt_options.hidden_fields = k : n.fmt_options = {
        hidden_fields: k
      }), A && (n.fmt_options ? n.fmt_options.hidden_facets = A : n.fmt_options = {
        hidden_facets: A
      }), O && (n.variations_map = JSON.stringify(O)), U && (n.pre_filter_expression = JSON.stringify(U)), N && (n.qs = JSON.stringify(N));
    }
    n._dt = Date.now(), n = _.cleanParams(n);
    var P = _.stringify(n), L = E ? "search/natural_language" : "search";
    return "".concat(C, "/").concat(L, "/").concat(_.encodeURIComponentRFC3986(_.trimNonBreakingSpaces(g)), "?").concat(P);
  }
  var u = /* @__PURE__ */ (function() {
    function g(s) {
      (0, a.default)(this, g), this.options = s || {}, this.eventDispatcher = new v(s.eventDispatcher);
    }
    return (0, y.default)(g, [{
      key: "getSearchResults",
      value: function(R, E) {
        var m = this, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, q = this.options.fetch, p;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          p = e && e.signal, _.applyNetworkTimeout(this.options, x, e);
        }
        try {
          C = h(R, E, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return q(C, {
          signal: p
        }).then(_.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(w) {
              w.result_id = t.result_id;
            }), m.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          if (t.response && t.response.redirect)
            return m.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          throw new Error("getSearchResults response data is malformed");
        });
      }
      /**
       * Retrieve voice search results from API
       *
       * @function getVoiceSearchResults
       * @description Retrieve voice search results from Constructor.io API
       * @param {string} query - Term to use to perform a voice search
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/search-search-resultsqueries for details
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope search results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.qsParam] - Parameters listed above can be serialized into a JSON object and parsed through this parameter. Please refer to https://docs.constructor.com/reference/v1-search-get-search-results
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/docs/products-search-learn-about-search
       * @example
       * constructorio.search.getVoiceSearchResults('show me lipstick');
       */
    }, {
      key: "getVoiceSearchResults",
      value: function(R, E) {
        var m = this, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, q = this.options.fetch, p;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          p = e && e.signal, _.applyNetworkTimeout(this.options, x, e);
        }
        try {
          var t = !0;
          C = h(R, E, this.options, t);
        } catch (w) {
          return Promise.reject(w);
        }
        return q(C, {
          signal: p
        }).then(_.convertResponseToJson).then(function(w) {
          if (w.response && w.response.results)
            return w.result_id && w.response.results.forEach(function(n) {
              n.result_id = w.result_id;
            }), m.eventDispatcher.queue("search.getVoiceSearchResults.completed", w), w;
          if (w.response && w.response.redirect)
            return m.eventDispatcher.queue("search.getVoiceSearchResults.completed", w), w;
          throw new Error("getVoiceSearchResults response data is malformed");
        });
      }
    }]);
  })();
  return st = u, st;
}
var at = { exports: {} }, vr;
function Ke() {
  return vr || (vr = 1, (function(i) {
    var a = Kr();
    function y(v, _, h) {
      return (_ = a(_)) in v ? Object.defineProperty(v, _, {
        value: h,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : v[_] = h, v;
    }
    i.exports = y, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(at)), at.exports;
}
var ut, hr;
function Ei() {
  if (hr) return ut;
  hr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = i(Ke());
  function _(q, p) {
    var e = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(q);
      p && (t = t.filter(function(w) {
        return Object.getOwnPropertyDescriptor(q, w).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function h(q) {
    for (var p = 1; p < arguments.length; p++) {
      var e = arguments[p] != null ? arguments[p] : {};
      p % 2 ? _(Object(e), !0).forEach(function(t) {
        (0, v.default)(q, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(e)) : _(Object(e)).forEach(function(t) {
        Object.defineProperty(q, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return q;
  }
  var u = Ne(), g = he();
  function s(q, p) {
    var e = p.apiKey, t = p.version, w = p.sessionId, n = p.clientId, f = p.userId, S = p.segments, l = p.testCells, o = {
      c: t
    };
    if (o.key = e, o.i = n, o.s = w, l && Object.keys(l).forEach(function(F) {
      o["ef-".concat(F)] = l[F];
    }), S && S.length && (o.us = S), f && (o.ui = String(f)), q) {
      var r = q.page, d = q.offset, c = q.resultsPerPage, b = q.filters, k = q.sortBy, A = q.sortOrder, O = q.section, N = q.fmtOptions, U = q.hiddenFields, I = q.hiddenFacets, P = q.variationsMap, L = q.qsParam, D = q.preFilterExpression, j = q.filterMatchTypes;
      g.isNil(r) || (o.page = r), g.isNil(d) || (o.offset = d), g.isNil(c) || (o.num_results_per_page = c), b && (o.filters = b), j && (o.filter_match_types = j), k && (o.sort_by = k), A && (o.sort_order = A), O && (o.section = O), N && (o.fmt_options = N), U && (o.fmt_options ? o.fmt_options.hidden_fields = U : o.fmt_options = {
        hidden_fields: U
      }), I && (o.fmt_options ? o.fmt_options.hidden_facets = I : o.fmt_options = {
        hidden_facets: I
      }), P && (o.variations_map = JSON.stringify(P)), D && (o.pre_filter_expression = JSON.stringify(D)), L && (o.qs = JSON.stringify(L));
    }
    return o._dt = Date.now(), o = g.cleanParams(o), o;
  }
  function R(q, p, e, t) {
    var w = t.serviceUrl;
    if (!q || typeof q != "string")
      throw new Error("filterName is a required parameter of type string");
    if (!p || typeof p != "string")
      throw new Error("filterValue is a required parameter of type string");
    var n = s(e, t), f = g.stringify(n);
    return "".concat(w, "/browse/").concat(g.encodeURIComponentRFC3986(g.trimNonBreakingSpaces(q)), "/").concat(g.encodeURIComponentRFC3986(g.trimNonBreakingSpaces(p)), "?").concat(f);
  }
  function E(q, p, e) {
    var t = e.serviceUrl;
    if (!q || !Array.isArray(q) || !q.length)
      throw new Error("ids is a required parameter of type array");
    var w = h(h({}, s(p, e)), {}, {
      ids: q
    }), n = g.stringify(w);
    return "".concat(t, "/browse/items?").concat(n);
  }
  function m(q, p) {
    var e = p.serviceUrl, t = h({}, s(q, p));
    delete t._dt;
    var w = g.stringify(t);
    return "".concat(e, "/browse/facets?").concat(w);
  }
  function x(q, p, e) {
    var t = e.serviceUrl;
    if (!q || typeof q != "string")
      throw new Error("facetName is a required parameter of type string");
    var w = h({}, s(p, e));
    w.facet_name = q, delete w._dt;
    var n = g.stringify(w);
    return "".concat(t, "/browse/facet_options?").concat(n);
  }
  var C = /* @__PURE__ */ (function() {
    function q(p) {
      (0, a.default)(this, q), this.options = p || {}, this.eventDispatcher = new u(p.eventDispatcher);
    }
    return (0, y.default)(q, [{
      key: "getBrowseResults",
      value: function(e, t, w) {
        var n = this, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S, l = this.options.fetch, o;
        if (typeof AbortController == "function") {
          var r = new AbortController();
          o = r && r.signal, g.applyNetworkTimeout(this.options, f, r);
        }
        try {
          S = R(e, t, w, this.options);
        } catch (d) {
          return Promise.reject(d);
        }
        return l(S, {
          signal: o
        }).then(g.convertResponseToJson).then(function(d) {
          if (d.response && d.response.results)
            return d.result_id && d.response.results.forEach(function(c) {
              c.result_id = d.result_id;
            }), n.eventDispatcher.queue("browse.getBrowseResults.completed", d), d;
          throw new Error("getBrowseResults response data is malformed");
        });
      }
      /**
       * Retrieve browse results from API using item id's
       *
       * @function getBrowseResultsForItemIds
       * @param {string[]} itemIds - Item id's of results to fetch
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-results for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {object} [parameters.filterMatchTypes] - An object specifying whether results must match `all`, `any` or `none` of a given filter. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope browse results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @example
       * constructorio.browse.getBrowseResultsForItemIds(['shirt-123', 'shirt-456', 'shirt-789'], {
       *     filters: {
       *         size: 'medium'
       *     },
       *     filterMatchTypes: {
       *        size: 'all'
       *     }
       * });
       */
    }, {
      key: "getBrowseResultsForItemIds",
      value: function(e, t) {
        var w = this, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f, S = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, n, o);
        }
        try {
          f = E(e, t, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return S(f, {
          signal: l
        }).then(g.convertResponseToJson).then(function(r) {
          if (r.response && r.response.results)
            return r.result_id && r.response.results.forEach(function(d) {
              d.result_id = r.result_id;
            }), w.eventDispatcher.queue("browse.getBrowseResultsForItemIds.completed", r), r;
          throw new Error("getBrowseResultsForItemIds response data is malformed");
        });
      }
      /**
       * Retrieve browse groups from API
       *
       * @function getBrowseGroups
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-groups/ for details
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-groups
       * @example
       * constructorio.browse.getBrowseGroups({
       *     filters: {
       *         group_id: 'drill_collection'
       *     },
       *     fmtOptions: {
       *         groups_max_depth: 2
       *     }
       * });
       */
    }, {
      key: "getBrowseGroups",
      value: function(e) {
        var t = this, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = this.options.fetch, f = this.options.serviceUrl, S = s(e, this.options), l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, w, o);
        }
        delete S._dt;
        var r = g.stringify(S), d = "".concat(f, "/browse/groups?").concat(r);
        return n(d, {
          signal: l
        }).then(g.convertResponseToJson).then(function(c) {
          if (c.response && c.response.groups)
            return t.eventDispatcher.queue("browse.getBrowseGroups.completed", c), c;
          throw new Error("getBrowseGroups response data is malformed");
        });
      }
      /**
       * Retrieve browse facets from API
       *
       * @function getBrowseFacets
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-facets/ for details
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/browse-browse-facets
       * @example
       * constructorio.browse.getBrowseFacets({
       *     page: 1,
       *     resultsPerPage: 10,
       * });
       */
    }, {
      key: "getBrowseFacets",
      value: function(e, t) {
        var w = this, n, f = this.options.fetch, S;
        if (typeof AbortController == "function") {
          var l = new AbortController();
          S = l && l.signal, g.applyNetworkTimeout(this.options, t, l);
        }
        try {
          n = m(e, this.options);
        } catch (o) {
          return Promise.reject(o);
        }
        return f(n, {
          signal: S
        }).then(g.convertResponseToJson).then(function(o) {
          if (o.response && o.response.facets)
            return w.eventDispatcher.queue("browse.getBrowseFacets.completed", o), o;
          throw new Error("getBrowseFacets response data is malformed");
        });
      }
      /**
       * Retrieve facet options from API
       *
       * @function getBrowseFacetOptions
       * @param {string} facetName - Name of the facet whose options to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-facet-options for details
       * @param {}
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-facet-options
       * @example
       * constructorio.browse.getBrowseFacetOptions('price', {
       * });
       */
    }, {
      key: "getBrowseFacetOptions",
      value: function(e) {
        var t = this, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f, S = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, n, o);
        }
        try {
          f = x(e, w, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return S(f, {
          signal: l
        }).then(g.convertResponseToJson).then(function(r) {
          if (r.response && r.response.facets)
            return t.eventDispatcher.queue("browse.getBrowseFacetOptions.completed", r), r;
          throw new Error("getBrowseFacetOptions response data is malformed");
        });
      }
    }]);
  })();
  return ut = C, ut;
}
var ct, gr;
function Ri() {
  if (gr) return ct;
  gr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = Ne(), _ = he(), h = _.convertResponseToJson, u = _.cleanParams, g = _.applyNetworkTimeout, s = _.trimNonBreakingSpaces, R = _.encodeURIComponentRFC3986, E = _.stringify;
  function m(C, q, p) {
    var e = p.apiKey, t = p.version, w = p.serviceUrl, n = p.sessionId, f = p.clientId, S = p.userId, l = p.segments, o = p.testCells, r = {
      c: t
    };
    if (r.key = e, r.i = f, r.s = n, !C || typeof C != "string")
      throw new Error("query is a required parameter of type string");
    if (o && Object.keys(o).forEach(function(D) {
      r["ef-".concat(D)] = o[D];
    }), l && l.length && (r.us = l), S && (r.ui = String(S)), q) {
      var d = q.numResults, c = q.resultsPerSection, b = q.filters, k = q.filtersPerSection, A = q.hiddenFields, O = q.variationsMap, N = q.preFilterExpression, U = q.qsParam, I = q.fmtOptions;
      d && (r.num_results = d), c && Object.keys(c).forEach(function(D) {
        r["num_results_".concat(D)] = c[D];
      }), b && (r.filters = b), k && Object.keys(k).forEach(function(D) {
        r["filters[".concat(D, "]")] = k[D];
      }), N && (r.pre_filter_expression = JSON.stringify(N)), I && (r.fmt_options = I), A && (r.fmt_options ? r.fmt_options.hidden_fields = A : r.fmt_options = {
        hidden_fields: A
      }), O && (r.variations_map = JSON.stringify(O)), U && (r.qs = JSON.stringify(U));
    }
    r._dt = Date.now(), r = u(r);
    var P = E(r), L = C.replace(/^\//, "|");
    return "".concat(w, "/autocomplete/").concat(R(s(L)), "?").concat(P);
  }
  var x = /* @__PURE__ */ (function() {
    function C(q) {
      (0, a.default)(this, C), this.options = q || {}, this.eventDispatcher = new v(q.eventDispatcher);
    }
    return (0, y.default)(C, [{
      key: "getAutocompleteResults",
      value: function(p, e) {
        var t = this, w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n, f = this.options.fetch, S;
        if (typeof AbortController == "function") {
          var l = new AbortController();
          S = l && l.signal, g(this.options, w, l);
        }
        try {
          n = m(p, e, this.options);
        } catch (o) {
          return Promise.reject(o);
        }
        return f(n, {
          signal: S
        }).then(h).then(function(o) {
          if (o.sections) {
            if (o.result_id) {
              var r = Object.keys(o.sections);
              r.forEach(function(d) {
                var c = o.sections[d];
                c.length && c.forEach(function(b) {
                  b.result_id = o.result_id;
                });
              });
            }
            return t.eventDispatcher.queue("autocomplete.getAutocompleteResults.completed", o), o;
          }
          throw new Error("getAutocompleteResults response data is malformed");
        });
      }
    }]);
  })();
  return ct = x, ct;
}
var lt, _r;
function xi() {
  if (_r) return lt;
  _r = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = Ne(), _ = he();
  function h(g, s, R) {
    var E = R.apiKey, m = R.version, x = R.serviceUrl, C = R.sessionId, q = R.userId, p = R.clientId, e = R.segments, t = {
      c: m
    };
    if (t.key = E, t.i = p, t.s = C, !g || typeof g != "string")
      throw new Error("podId is a required parameter of type string");
    if (e && e.length && (t.us = e), q && (t.ui = String(q)), s) {
      var w = s.numResults, n = s.itemIds, f = s.section, S = s.term, l = s.filters, o = s.variationsMap, r = s.hiddenFields, d = s.preFilterExpression, c = s.fmtOptions;
      _.isNil(w) || (t.num_results = w), n && (t.item_id = n), f && (t.section = f), S && (t.term = S), l && (t.filters = l), c && (t.fmt_options = c), r && (t.fmt_options ? t.fmt_options.hidden_fields = r : t.fmt_options = {
        hidden_fields: r
      }), o && (t.variations_map = JSON.stringify(o)), d && (t.pre_filter_expression = JSON.stringify(d));
    }
    t = _.cleanParams(t);
    var b = _.stringify(t);
    return "".concat(x, "/recommendations/v1/pods/").concat(_.encodeURIComponentRFC3986(_.trimNonBreakingSpaces(g)), "?").concat(b);
  }
  var u = /* @__PURE__ */ (function() {
    function g(s) {
      (0, a.default)(this, g), this.options = s || {}, this.eventDispatcher = new v(s.eventDispatcher);
    }
    return (0, y.default)(g, [{
      key: "getRecommendations",
      value: function(R, E) {
        var m = this, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C, q = this.options.fetch, p;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          p = e && e.signal, _.applyNetworkTimeout(this.options, x, e);
        }
        try {
          C = h(R, E, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return q(C, {
          signal: p
        }).then(_.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(w) {
              w.result_id = t.result_id;
            }), m.eventDispatcher.queue("recommendations.getRecommendations.completed", t), t;
          throw new Error("getRecommendations response data is malformed");
        });
      }
    }]);
  })();
  return lt = u, lt;
}
var Ve = { exports: {} }, pr;
function Ci() {
  if (pr) return Ve.exports;
  pr = 1;
  var i = fe(), a = i(Re()), y = (typeof Reflect > "u" ? "undefined" : (0, a.default)(Reflect)) === "object" ? Reflect : null, v = y && typeof y.apply == "function" ? y.apply : function(o, r, d) {
    return Function.prototype.apply.call(o, r, d);
  }, _;
  y && typeof y.ownKeys == "function" ? _ = y.ownKeys : Object.getOwnPropertySymbols ? _ = function(o) {
    return Object.getOwnPropertyNames(o).concat(Object.getOwnPropertySymbols(o));
  } : _ = function(o) {
    return Object.getOwnPropertyNames(o);
  };
  function h(l) {
    console && console.warn && console.warn(l);
  }
  var u = Number.isNaN || function(o) {
    return o !== o;
  };
  function g() {
    g.init.call(this);
  }
  Ve.exports = g, Ve.exports.once = n, g.EventEmitter = g, g.prototype._events = void 0, g.prototype._eventsCount = 0, g.prototype._maxListeners = void 0;
  var s = 10;
  function R(l) {
    if (typeof l != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + (0, a.default)(l));
  }
  Object.defineProperty(g, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(o) {
      if (typeof o != "number" || o < 0 || u(o))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + o + ".");
      s = o;
    }
  }), g.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, g.prototype.setMaxListeners = function(o) {
    if (typeof o != "number" || o < 0 || u(o))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + o + ".");
    return this._maxListeners = o, this;
  };
  function E(l) {
    return l._maxListeners === void 0 ? g.defaultMaxListeners : l._maxListeners;
  }
  g.prototype.getMaxListeners = function() {
    return E(this);
  }, g.prototype.emit = function(o) {
    for (var r = [], d = 1; d < arguments.length; d++) r.push(arguments[d]);
    var c = o === "error", b = this._events;
    if (b !== void 0) c = c && b.error === void 0;
    else if (!c) return !1;
    if (c) {
      var k;
      if (r.length > 0 && (k = r[0]), k instanceof Error)
        throw k;
      var A = new Error("Unhandled error." + (k ? " (" + k.message + ")" : ""));
      throw A.context = k, A;
    }
    var O = b[o];
    if (O === void 0) return !1;
    if (typeof O == "function")
      v(O, this, r);
    else
      for (var N = O.length, U = e(O, N), d = 0; d < N; ++d) v(U[d], this, r);
    return !0;
  };
  function m(l, o, r, d) {
    var c, b, k;
    if (R(r), b = l._events, b === void 0 ? (b = l._events = /* @__PURE__ */ Object.create(null), l._eventsCount = 0) : (b.newListener !== void 0 && (l.emit("newListener", o, r.listener ? r.listener : r), b = l._events), k = b[o]), k === void 0)
      k = b[o] = r, ++l._eventsCount;
    else if (typeof k == "function" ? k = b[o] = d ? [r, k] : [k, r] : d ? k.unshift(r) : k.push(r), c = E(l), c > 0 && k.length > c && !k.warned) {
      k.warned = !0;
      var A = new Error("Possible EventEmitter memory leak detected. " + k.length + " " + String(o) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      A.name = "MaxListenersExceededWarning", A.emitter = l, A.type = o, A.count = k.length, h(A);
    }
    return l;
  }
  g.prototype.addListener = function(o, r) {
    return m(this, o, r, !1);
  }, g.prototype.on = g.prototype.addListener, g.prototype.prependListener = function(o, r) {
    return m(this, o, r, !0);
  };
  function x() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function C(l, o, r) {
    var d = {
      fired: !1,
      wrapFn: void 0,
      target: l,
      type: o,
      listener: r
    }, c = x.bind(d);
    return c.listener = r, d.wrapFn = c, c;
  }
  g.prototype.once = function(o, r) {
    return R(r), this.on(o, C(this, o, r)), this;
  }, g.prototype.prependOnceListener = function(o, r) {
    return R(r), this.prependListener(o, C(this, o, r)), this;
  }, g.prototype.removeListener = function(o, r) {
    var d, c, b, k, A;
    if (R(r), c = this._events, c === void 0) return this;
    if (d = c[o], d === void 0) return this;
    if (d === r || d.listener === r)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[o], c.removeListener && this.emit("removeListener", o, d.listener || r));
    else if (typeof d != "function") {
      for (b = -1, k = d.length - 1; k >= 0; k--)
        if (d[k] === r || d[k].listener === r) {
          A = d[k].listener, b = k;
          break;
        }
      if (b < 0) return this;
      b === 0 ? d.shift() : t(d, b), d.length === 1 && (c[o] = d[0]), c.removeListener !== void 0 && this.emit("removeListener", o, A || r);
    }
    return this;
  }, g.prototype.off = g.prototype.removeListener, g.prototype.removeAllListeners = function(o) {
    var r, d, c;
    if (d = this._events, d === void 0) return this;
    if (d.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : d[o] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete d[o]), this;
    if (arguments.length === 0) {
      var b = Object.keys(d), k;
      for (c = 0; c < b.length; ++c)
        k = b[c], k !== "removeListener" && this.removeAllListeners(k);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (r = d[o], typeof r == "function")
      this.removeListener(o, r);
    else if (r !== void 0)
      for (c = r.length - 1; c >= 0; c--)
        this.removeListener(o, r[c]);
    return this;
  };
  function q(l, o, r) {
    var d = l._events;
    if (d === void 0) return [];
    var c = d[o];
    return c === void 0 ? [] : typeof c == "function" ? r ? [c.listener || c] : [c] : r ? w(c) : e(c, c.length);
  }
  g.prototype.listeners = function(o) {
    return q(this, o, !0);
  }, g.prototype.rawListeners = function(o) {
    return q(this, o, !1);
  }, g.listenerCount = function(l, o) {
    return typeof l.listenerCount == "function" ? l.listenerCount(o) : p.call(l, o);
  }, g.prototype.listenerCount = p;
  function p(l) {
    var o = this._events;
    if (o !== void 0) {
      var r = o[l];
      if (typeof r == "function")
        return 1;
      if (r !== void 0)
        return r.length;
    }
    return 0;
  }
  g.prototype.eventNames = function() {
    return this._eventsCount > 0 ? _(this._events) : [];
  };
  function e(l, o) {
    for (var r = new Array(o), d = 0; d < o; ++d) r[d] = l[d];
    return r;
  }
  function t(l, o) {
    for (; o + 1 < l.length; o++) l[o] = l[o + 1];
    l.pop();
  }
  function w(l) {
    for (var o = new Array(l.length), r = 0; r < o.length; ++r)
      o[r] = l[r].listener || l[r];
    return o;
  }
  function n(l, o) {
    return new Promise(function(r, d) {
      function c(k) {
        l.removeListener(o, b), d(k);
      }
      function b() {
        typeof l.removeListener == "function" && l.removeListener("error", c), r([].slice.call(arguments));
      }
      S(l, o, b, {
        once: !0
      }), o !== "error" && f(l, c, {
        once: !0
      });
    });
  }
  function f(l, o, r) {
    typeof l.on == "function" && S(l, "error", o, r);
  }
  function S(l, o, r, d) {
    if (typeof l.on == "function")
      d.once ? l.once(o, r) : l.on(o, r);
    else if (typeof l.addEventListener == "function")
      l.addEventListener(o, function c(b) {
        d.once && l.removeEventListener(o, c), r(b);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (0, a.default)(l));
  }
  return Ve.exports;
}
var ft, yr;
function Ai() {
  return yr || (yr = 1, ft = ["Googlebot/", "Googlebot-Mobile", "Googlebot-Image", "Googlebot-News", "Googlebot-Video", "AdsBot-Google([^-]|$)", "AdsBot-Google-Mobile", "Feedfetcher-Google", "Mediapartners-Google", "Mediapartners \\(Googlebot\\)", "APIs-Google", "bingbot", "Slurp", "[wW]get", "curl", "LinkedInBot", "Python-urllib", "python-requests", "libwww", "httpunit", "nutch", "Go-http-client", "phpcrawl", "msnbot", "jyxobot", "FAST-WebCrawler", "FAST Enterprise Crawler", "BIGLOTRON", "Teoma", "convera", "seekbot", "Gigabot", "Gigablast", "exabot", "ia_archiver", "GingerCrawler", "webmon ", "HTTrack", "grub\\.org", "UsineNouvelleCrawler", "antibot", "netresearchserver", "speedy", "fluffy", "bibnum\\.bnf", "findlink", "msrbot", "panscient", "yacybot", "AISearchBot", "ips-agent", "tagoobot", "MJ12bot", "woriobot", "yanga", "buzzbot", "mlbot", "YandexBot", "yandex\\.com/bots", "purebot", "Linguee Bot", "CyberPatrol", "voilabot", "Baiduspider", "citeseerxbot", "spbot", "twengabot", "postrank", "turnitinbot", "scribdbot", "page2rss", "sitebot", "linkdex", "Adidxbot", "blekkobot", "ezooms", "dotbot", "Mail\\.RU_Bot", "discobot", "heritrix", "findthatfile", "europarchive\\.org", "NerdByNature\\.Bot", "sistrix crawler", "Ahrefs(Bot|SiteAudit)", "fuelbot", "CrunchBot", "centurybot9", "IndeedBot", "mappydata", "woobot", "ZoominfoBot", "PrivacyAwareBot", "Multiviewbot", "SWIMGBot", "Grobbot", "eright", "Apercite", "semanticbot", "Aboundex", "domaincrawler", "wbsearchbot", "summify", "CCBot", "edisterbot", "seznambot", "ec2linkfinder", "gslfbot", "aiHitBot", "intelium_bot", "facebookexternalhit", "Yeti", "RetrevoPageAnalyzer", "lb-spider", "Sogou", "lssbot", "careerbot", "wotbox", "wocbot", "ichiro", "DuckDuckBot", "lssrocketcrawler", "drupact", "webcompanycrawler", "acoonbot", "openindexspider", "gnam gnam spider", "web-archive-net\\.com\\.bot", "backlinkcrawler", "coccoc", "integromedb", "content crawler spider", "toplistbot", "it2media-domain-crawler", "ip-web-crawler\\.com", "siteexplorer\\.info", "elisabot", "proximic", "changedetection", "arabot", "WeSEE:Search", "niki-bot", "CrystalSemanticsBot", "rogerbot", "360Spider", "psbot", "InterfaxScanBot", "CC Metadata Scaper", "g00g1e\\.net", "GrapeshotCrawler", "urlappendbot", "brainobot", "fr-crawler", "binlar", "SimpleCrawler", "Twitterbot", "cXensebot", "smtbot", "bnf\\.fr_bot", "A6-Indexer", "ADmantX", "Facebot", "OrangeBot/", "memorybot", "AdvBot", "MegaIndex", "SemanticScholarBot", "ltx71", "nerdybot", "xovibot", "BUbiNG", "Qwantify", "archive\\.org_bot", "Applebot", "TweetmemeBot", "crawler4j", "findxbot", "S[eE][mM]rushBot", "yoozBot", "lipperhey", "Y!J", "Domain Re-Animator Bot", "AddThis", "Screaming Frog SEO Spider", "MetaURI", "Scrapy", "Livelap[bB]ot", "OpenHoseBot", "CapsuleChecker", "collection@infegy\\.com", "IstellaBot", "DeuSu/", "betaBot", "Cliqzbot/", "MojeekBot/", "netEstate NE Crawler", "SafeSearch microdata crawler", "Gluten Free Crawler/", "Sonic", "Sysomos", "Trove", "deadlinkchecker", "Slack-ImgProxy", "Embedly", "RankActiveLinkBot", "iskanie", "SafeDNSBot", "SkypeUriPreview", "Veoozbot", "Slackbot", "redditbot", "datagnionbot", "Google-Adwords-Instant", "adbeat_bot", "WhatsApp", "contxbot", "pinterest", "electricmonk", "GarlikCrawler", "BingPreview/", "vebidoobot", "FemtosearchBot", "Yahoo Link Preview", "MetaJobBot", "DomainStatsBot", "mindUpBot", "Daum/", "Jugendschutzprogramm-Crawler", "Xenu Link Sleuth", "Pcore-HTTP", "moatbot", "KosmioBot", "pingdom", "PhantomJS", "Gowikibot", "PiplBot", "Discordbot", "TelegramBot", "Jetslide", "newsharecounts", "James BOT", "Barkrowler", "TinEye", "SocialRankIOBot", "trendictionbot", "Ocarinabot", "epicbot", "Primalbot", "DuckDuckGo-Favicons-Bot", "GnowitNewsbot", "Leikibot", "LinkArchiver", "YaK/", "PaperLiBot", "Digg Deeper", "dcrawl", "Snacktory", "AndersPinkBot", "Fyrebot", "EveryoneSocialBot", "Mediatoolkitbot", "Luminator-robots", "ExtLinksBot", "SurveyBot", "NING/", "okhttp", "Nuzzel", "omgili", "PocketParser", "YisouSpider", "um-LN", "ToutiaoSpider", "MuckRack", "Jamie's Spider", "AHC/", "NetcraftSurveyAgent", "Laserlikebot", "Apache-HttpClient", "AppEngine-Google", "Jetty", "Upflow", "Thinklab", "Traackr\\.com", "Twurly", "Mastodon", "http_get", "DnyzBot", "botify", "007ac9 Crawler", "BehloolBot", "BrandVerity", "check_http", "BDCbot", "ZumBot", "EZID", "ICC-Crawler", "ArchiveBot", "^LCC ", "filterdb\\.iss\\.net/crawler", "BLP_bbot", "BomboraBot", "Buck/", "Companybook-Crawler", "Genieo", "magpie-crawler", "MeltwaterNews", "Moreover", "newspaper/", "ScoutJet", "(^| )sentry/", "StorygizeBot", "UptimeRobot", "OutclicksBot", "seoscanners", "Hatena", "Google Web Preview", "MauiBot", "AlphaBot", "SBL-BOT", "IAS crawler", "adscanner", "Netvibes", "acapbot", "Baidu-YunGuanCe", "bitlybot", "blogmuraBot", "Bot\\.AraTurka\\.com", "bot-pge\\.chlooe\\.com", "BoxcarBot", "BTWebClient", "ContextAd Bot", "Digincore bot", "Disqus", "Feedly", "Fetch/", "Fever", "Flamingo_SearchEngine", "FlipboardProxy", "g2reader-bot", "imrbot", "K7MLWCBot", "Kemvibot", "Landau-Media-Spider", "linkapediabot", "vkShare", "Siteimprove\\.com", "BLEXBot/", "DareBoost", "ZuperlistBot/", "Miniflux/", "Feedspotbot/", "Diffbot/", "SEOkicks", "tracemyfile", "Nimbostratus-Bot", "Bytespider", "BTTAgent", "OnCrawl"]), ft;
}
var dt, wr;
function Oi() {
  if (wr) return dt;
  wr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = Kt(), _ = Ai(), h = he(), u = "_constructorio_is_human", g = ["scroll", "resize", "touchmove", "mouseover", "mousemove", "keydown", "keypress", "keyup", "focus"], s = /* @__PURE__ */ (function() {
    function R() {
      var E = this;
      (0, a.default)(this, R), this.hasPerformedHumanEvent = this.getIsHumanFromSessionStorage();
      var m = function() {
        E.hasPerformedHumanEvent = !0, v.session.set(u, !0), g.forEach(function(C) {
          h.removeEventListener(C, m, !0);
        });
      };
      this.hasPerformedHumanEvent || g.forEach(function(x) {
        h.addEventListener(x, m, !0);
      });
    }
    return (0, y.default)(R, [{
      key: "getIsHumanFromSessionStorage",
      value: function() {
        return !!v.session.get(u) || !1;
      }
      // Return boolean indicating if user is a bot
      // ...if it has a bot-like useragent
      // ...or uses webdriver
      // ...or has not performed a human event
    }, {
      key: "isBot",
      value: function() {
        var m = h.getNavigator(), x = m.userAgent, C = m.webdriver, q = new RegExp("(".concat(_.join("|"), ")"));
        return !!(x.match(q) || C || !this.getIsHumanFromSessionStorage());
      }
    }]);
  })();
  return dt = s, dt;
}
var vt, br;
function Ti() {
  if (br) return vt;
  br = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = Kt(), _ = Oi(), h = he(), u = he(), g = u.obfuscatePiiRequest, s = "_constructorio_requests", R = 18e4, E = /* @__PURE__ */ (function() {
    function m(x, C) {
      var q = this;
      (0, a.default)(this, m), this.options = x, this.eventemitter = C, this.humanity = new _(), this.requestPending = !1, this.pageUnloading = !1, this.sendTrackingEvents = !!(x && x.sendTrackingEvents === !0), h.addEventListener("visibilitychange", function() {
        document.visibilityState === "hidden" ? q.pageUnloading = !0 : document.visibilityState === "visible" && q.pageUnloading === !0 && (q.pageUnloading = !1, q.sendTrackingEvents && q.send());
      }), this.sendTrackingEvents && this.send();
    }
    return (0, y.default)(m, [{
      key: "queue",
      value: function(C) {
        var q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        if (this.sendTrackingEvents && (!h.canUseDOM() || !this.humanity.isBot())) {
          var t = m.get(), w = g(C);
          t.push({
            url: w,
            method: q,
            body: p,
            networkParameters: e
          }), m.set(t);
        }
      }
      // Read from queue and send events to server
    }, {
      key: "sendEvents",
      value: function() {
        var C = this, q = this.options.fetch, p = m.get();
        if (
          // Consider user "human" if no DOM context is available
          (!h.canUseDOM() || !this.humanity.isBot()) && !this.requestPending && !this.pageUnloading && p.length
        ) {
          var e, t = p.shift(), w = t, n = w.networkParameters, f, S = this;
          if (m.set(p), n && typeof AbortController == "function") {
            var l = new AbortController();
            f = l.signal, h.applyNetworkTimeout(this.options, n, l);
          }
          if (typeof t == "string" && (t = {
            url: t,
            method: "GET"
          }), t.url) {
            var o = t.url.match(/\?.*_dt=([^&]+)/), r = parseInt(o && o[1], 10), d = +/* @__PURE__ */ new Date();
            if (r && Number.isInteger(r) && d - r > R) {
              this.sendTrackingEvents = !1, m.remove();
              return;
            }
          }
          t.method === "GET" && (e = q(t.url, {
            signal: f
          })), t.method === "POST" && (e = q(t.url, {
            method: t.method,
            body: JSON.stringify(t.body),
            mode: "cors",
            headers: {
              "Content-Type": "text/plain"
            },
            signal: f
          })), e && (this.requestPending = !0, e.then(function(c) {
            c.ok ? (S.eventemitter && S.eventemitter.emit("success", {
              url: t.url,
              method: t.method,
              message: "ok"
            }), C.requestPending = !1, C.send()) : c.json().then(function(b) {
              S.eventemitter && S.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: b && b.message
              }), C.requestPending = !1, C.send();
            }).catch(function(b) {
              S.eventemitter && S.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: b.type
              }), C.requestPending = !1, C.send();
            });
          }).catch(function(c) {
            S.eventemitter && S.eventemitter.emit("error", {
              url: t.url,
              method: t.method,
              message: c && c.toString && c.toString()
            }), C.requestPending = !1, C.send();
          }));
        }
      }
      // Read from queue and send requests to server
    }, {
      key: "send",
      value: function() {
        this.sendTrackingEvents && (this.options && this.options.trackingSendDelay === 0 ? this.sendEvents() : setTimeout(this.sendEvents.bind(this), this.options && this.options.trackingSendDelay || 250));
      }
      // Return current request queue
    }], [{
      key: "get",
      value: function() {
        return v.local.get(s) || [];
      }
      // Update current request queue
    }, {
      key: "set",
      value: function(C) {
        !C || Array.isArray(C) && C.length === 0 ? m.remove() : v.local.set(s, C);
        var q = m.get();
        Array.isArray(q) && q.length !== C.length && (this.sendTrackingEvents = !1, m.remove());
      }
      // Remove current request queue key
    }, {
      key: "remove",
      value: function() {
        v.local.remove(s);
      }
    }]);
  })();
  return vt = E, vt;
}
var ht, mr;
function Ii() {
  if (mr) return ht;
  mr = 1;
  var i = fe(), a = i(Re()), y = i(Ke()), v = i(ge()), _ = i(_e());
  function h(q, p) {
    var e = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(q);
      p && (t = t.filter(function(w) {
        return Object.getOwnPropertyDescriptor(q, w).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function u(q) {
    for (var p = 1; p < arguments.length; p++) {
      var e = arguments[p] != null ? arguments[p] : {};
      p % 2 ? h(Object(e), !0).forEach(function(t) {
        (0, y.default)(q, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(e)) : h(Object(e)).forEach(function(t) {
        Object.defineProperty(q, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return q;
  }
  var g = Ci(), s = he(), R = Ti(), E = 2048;
  function m(q, p) {
    var e = p.apiKey, t = p.version, w = p.sessionId, n = p.clientId, f = p.userId, S = p.segments, l = p.testCells, o = p.requestMethod, r = p.beaconMode, d = s.getWindowLocation(), c = d.host, b = d.pathname, k = d.search, A = p.sendReferrerWithTrackingEvents !== !1, O = Object.assign(q);
    if (t && (O.c = t), n && (O.i = n), w && (O.s = w), f && (O.ui = String(f)), S && S.length && (O.us = S), e && (O.key = e), l && Object.keys(l).forEach(function(I) {
      O["ef-".concat(I)] = l[I];
    }), r && o && o.match(/POST/i) && (O.beacon = !0), A && c && (O.origin_referrer = c, b && (O.origin_referrer += b), k))
      try {
        var N = [], U = new URLSearchParams(k);
        U.forEach(function(I, P) {
          P.match(/utm_/) && N.push("".concat(P, "=").concat(I));
        }), N.length && (O.origin_referrer += "?".concat(N.join("&")));
      } catch {
      }
    return O._dt = Date.now(), O = s.cleanParams(O), O;
  }
  function x(q, p) {
    return s.stringify(m(q, p));
  }
  var C = /* @__PURE__ */ (function() {
    function q(p) {
      (0, v.default)(this, q), this.options = p || {}, this.eventemitter = new g(), this.requests = new R(p, this.eventemitter);
    }
    return (0, _.default)(q, [{
      key: "trackSessionStartV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/v2/behavioral_action/session_start?");
        return this.requests.queue("".concat(t).concat(x({}, this.options)), "POST", void 0, e), this.requests.send(), !0;
      }
      /**
       * Send session start event to API
       *
       * @function trackSessionStart
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.trackSessionStart();
       */
    }, {
      key: "trackSessionStart",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), w = {
          action: "session_start"
        };
        return this.requests.queue("".concat(t).concat(x(w, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       * @private
       * @function trackInputFocusV2
       * @param {string} userInput - The current autocomplete search query
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocusV2("text");
       */
    }, {
      key: "trackInputFocusV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/focus?"), f = {}, S = t.analyticsTags, l = S === void 0 ? null : S;
        l && (f.analytics_tags = l), f.user_input = e;
        var o = "POST", r = m(f, u(u({}, this.options), {}, {
          requestMethod: o
        }));
        return this.requests.queue("".concat(n).concat(x({}, this.options)), o, r, w), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       *
       * @function trackInputFocus
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocus();
       */
    }, {
      key: "trackInputFocus",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), w = {
          action: "focus"
        };
        return this.requests.queue("".concat(t).concat(x(w, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send item detail load event to API
       *
       * @function trackItemDetailLoad
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.url - Current page URL
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User loaded an item detail page
       * @example
       * constructorio.tracker.trackItemDetailLoad(
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         url: 'https://constructor.io/product/KMH876',
       *     },
       * );
       */
    }, {
      key: "trackItemDetailLoad",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/item_detail_load?"), n = {}, f = {}, S = e.item_name, l = e.name, o = e.item_id, r = e.customer_id, d = e.customerId, c = d === void 0 ? r : d, b = e.variation_id, k = e.itemName, A = k === void 0 ? S || l : k, O = e.itemId, N = O === void 0 ? o || c : O, U = e.variationId, I = U === void 0 ? b : U, P = e.url, L = e.analyticsTags;
          A && (f.item_name = A), N && (f.item_id = N), I && (f.variation_id = I), L && (f.analytics_tags = L), P && (f.url = s.truncateString(P, E));
          var D = "".concat(w).concat(x(n, this.options)), j = "POST", F = m(f, u(u({}, this.options), {}, {
            requestMethod: j
          }));
          return this.requests.queue(D, j, F, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send autocomplete select event to API
       * @private
       * @function trackAutocompleteSelectV2
       * @param {string} itemName - Name of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.section] - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.variationId] - Variation id of the selected item
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelectV2(
       *     'T-Shirt',
       *      {
       *          userInput: 'Shirt',
       *          section: 'Products',
       *          tr: 'click',
       *          groupId: '88JU230',
       *          itemId: '12345',
       *          variationId: '12345-A',
       *          slCampaignId: 'Campaign 123',
       *          slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelectV2",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/autocomplete_select?"), f = t.original_query, S = t.originalQuery, l = S === void 0 ? f : S, o = t.user_input, r = t.userInput, d = r === void 0 ? l || o : r, c = t.original_section, b = t.section, k = b === void 0 ? c : b, A = t.tr, O = t.group_id, N = t.groupId, U = N === void 0 ? O : N, I = t.item_id, P = t.itemId, L = P === void 0 ? I : P, D = t.variation_id, j = t.variationId, F = j === void 0 ? D : j, M = t.slCampaignId, V = t.slCampaignOwner, z = {}, B = {
              user_input: d,
              tr: A,
              group_id: U,
              item_id: L,
              variation_id: F,
              item_name: e,
              section: k
            };
            k && (z.section = k), M && (B.sl_campaign_id = M), V && (B.sl_campaign_owner = V);
            var G = "".concat(n).concat(x(z, this.options)), H = "POST", W = m(B, u(u({}, this.options), {}, {
              requestMethod: H
            }));
            return this.requests.queue(G, H, W, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete select event to API
       *
       * @function trackAutocompleteSelect
       * @param {string} term - Term of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} parameters.section - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelect(
       *     'T-Shirt',
       *      {
       *         originalQuery: 'Shirt',
       *         section: 'Products',
       *         tr: 'click',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *         itemId: '12345',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelect",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(s.encodeURIComponentRFC3986(s.trimNonBreakingSpaces(e)), "/select?"), f = {}, S = t.original_query, l = t.originalQuery, o = l === void 0 ? S : l, r = t.section, d = t.original_section, c = t.originalSection, b = c === void 0 ? d : c, k = t.tr, A = t.group_id, O = t.groupId, N = O === void 0 ? A : O, U = t.display_name, I = t.displayName, P = I === void 0 ? U : I, L = t.item_id, D = t.itemId, j = D === void 0 ? L : D, F = t.slCampaignOwner, M = t.slCampaignId;
            return o && (f.original_query = o), k && (f.tr = k), (b || r) && (f.section = b || r), N && (f.group = {
              group_id: N,
              display_name: P
            }), j && (f.item_id = j), M && (f.sl_campaign_id = M), F && (f.sl_campaign_owner = F), this.requests.queue("".concat(n).concat(x(f, this.options)), void 0, void 0, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       * @private
       * @function trackSearchSubmitV2
       * @param {string} searchTerm - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmitV2(
       *     'T-Shirt',
       *     {
       *         userInput: 'Shirt',
       *         groupId: '88JU230',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmitV2",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_submit?"), f = t.original_query, S = t.originalQuery, l = S === void 0 ? f : S, o = t.user_input, r = t.userInput, d = r === void 0 ? l || o : r, c = t.group_id, b = t.groupId, k = b === void 0 ? c : b, A = t.section, O = t.analyticsTags, N = O === void 0 ? null : O, U = {}, I = {
              user_input: d,
              search_term: e,
              section: A
            };
            k && (I.filters = {
              group_id: k
            }), A && (U.section = A), N && (I.analytics_tags = N);
            var P = "".concat(n).concat(x(U, this.options)), L = "POST", D = m(I, u(u({}, this.options), {}, {
              requestMethod: L
            }));
            return this.requests.queue(P, L, D, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       *
       * @function trackSearchSubmit
       * @param {string} term - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmit(
       *     'T-Shirt',
       *     {
       *         originalQuery: 'Shirt',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmit",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(s.encodeURIComponentRFC3986(s.trimNonBreakingSpaces(e)), "/search?"), f = {}, S = t.original_query, l = t.originalQuery, o = l === void 0 ? S : l, r = t.group_id, d = t.groupId, c = d === void 0 ? r : d, b = t.display_name, k = t.displayName, A = k === void 0 ? b : k, O = t.analyticsTags;
            return o && (f.original_query = o), c && (f.group = {
              group_id: c,
              display_name: A
            }), O && (f.analytics_tags = O), this.requests.queue("".concat(n).concat(x(f, this.options)), void 0, void 0, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send search results loaded event to API
       *
       * @function trackSearchResultsLoaded
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - URL of the search results page
       * @param {object[]} parameters.items - List of product item unique identifiers in search results listing
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Current page of search results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultsLoaded(
       *     'T-Shirt',
       *     {
       *         resultCount: 167,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *         sortOrder: 'ascending'
       *         sortBy: 'price',
       *         resultPage: 3,
       *         resultCount: 20
       *     },
       * );
       */
    }, {
      key: "trackSearchResultsLoaded",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n, f, S, l = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_load?"), o = t.num_results, r = t.numResults, d = r === void 0 ? o : r, c = t.result_count, b = t.customerIds, k = t.customer_ids, A = k === void 0 ? b : k, O = t.itemIds, N = t.item_ids, U = N === void 0 ? O : N, I = t.items, P = I === void 0 ? A || U : I, L = t.result_page, D = t.resultPage, j = D === void 0 ? L : D, F = t.result_id, M = t.resultId, V = M === void 0 ? F : M, z = t.sort_order, B = t.sortOrder, G = B === void 0 ? z : B, H = t.sort_by, W = t.sortBy, Y = W === void 0 ? H : W, re = t.selected_filters, K = t.selectedFilters, ae = K === void 0 ? re : K, te = t.url, oe = te === void 0 ? ((n = s.getWindowLocation()) === null || n === void 0 ? void 0 : n.href) || "N/A" : te, ue = t.section, Z = t.analyticsTags, de = t.resultCount, ee = de === void 0 ? (f = (S = d ?? c) !== null && S !== void 0 ? S : P?.length) !== null && f !== void 0 ? f : 0 : de, ye = {}, ve;
            if (P && Array.isArray(P) && P.length !== 0) {
              var we = P.slice(0, 100);
              typeof P[0] == "string" || typeof P[0] == "number" ? ve = we.map(function(xe) {
                return {
                  item_id: String(xe)
                };
              }) : ve = we.map(function(xe) {
                return s.toSnakeCaseKeys(xe, !1);
              });
            }
            ue && (ye.section = ue);
            var Me = {
              search_term: e,
              result_count: ee,
              items: ve,
              result_page: j,
              result_id: V,
              sort_order: G,
              sort_by: Y,
              selected_filters: ae,
              url: s.truncateString(oe, E),
              section: ue,
              analytics_tags: Z
            }, ze = "".concat(l).concat(x(ye, this.options)), Ue = "POST", Ge = m(Me, u(u({}, this.options), {}, {
              requestMethod: Ue
            }));
            return this.requests.queue(ze, Ue, Ge, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       * @private
       * @function trackSearchResultClickV2
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name (Either itemName or itemId is required)
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Number of results in total
       * @param {number} [parameters.resultPage] - Current page of results
       * @param {string} [parameters.resultPositionOnPage] - Position of selected items on page
       * @param {string} [parameters.numResultsPerPage] - Number of results per page
       * @param {object} [parameters.selectedFilters] - Key - Value map of selected filters
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClickV2(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClickV2",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_click?"), f = t.num_results, S = t.customer_id, l = t.item_id, o = t.itemId, r = o === void 0 ? S || l : o, d = t.name, c = t.item_name, b = t.itemName, k = b === void 0 ? d || c : b, A = t.variation_id, O = t.variationId, N = O === void 0 ? A : O, U = t.result_id, I = t.resultId, P = I === void 0 ? U : I, L = t.result_count, D = t.resultCount, j = D === void 0 ? f || L : D, F = t.result_page, M = t.resultPage, V = M === void 0 ? F : M, z = t.result_position_on_page, B = t.resultPositionOnPage, G = B === void 0 ? z : B, H = t.num_results_per_page, W = t.numResultsPerPage, Y = W === void 0 ? H : W, re = t.selected_filters, K = t.selectedFilters, ae = K === void 0 ? re : K, te = t.section, oe = t.analyticsTags, ue = t.slCampaignId, Z = t.slCampaignOwner, de = {
              sl_campaign_id: ue,
              sl_campaign_owner: Z,
              item_name: k,
              item_id: r,
              variation_id: N,
              result_id: P,
              result_count: j,
              result_page: V,
              result_position_on_page: G,
              num_results_per_page: Y,
              selected_filters: ae,
              section: te,
              search_term: e,
              analytics_tags: oe
            }, ee = {};
            te && (ee.section = te);
            var ye = "".concat(n).concat(x(ee, this.options)), ve = "POST", we = m(de, u(u({}, this.options), {}, {
              requestMethod: ve
            }));
            return this.requests.queue(ye, ve, we, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       *
       * @function trackSearchResultClick
       * @param {string} term - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {string} [parameters.itemIsConvertible] - Whether or not an item is available for a conversion
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClick(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClick",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(s.encodeURIComponentRFC3986(s.trimNonBreakingSpaces(e)), "/click_through?"), f = {}, S = t.item_name, l = t.name, o = t.itemName, r = o === void 0 ? S || l : o, d = t.item_id, c = t.itemId, b = c === void 0 ? d : c, k = t.customer_id, A = t.customerId, O = A === void 0 ? k || b : A, N = t.variation_id, U = t.variationId, I = U === void 0 ? N : U, P = t.result_id, L = t.resultId, D = L === void 0 ? P : L, j = t.item_is_convertible, F = t.itemIsConvertible, M = F === void 0 ? j : F, V = t.section, z = t.analyticsTags, B = t.slCampaignOwner, G = t.slCampaignId;
            return r && (f.name = r), O && (f.customer_id = O), I && (f.variation_id = I), D && (f.result_id = D), typeof M == "boolean" && (f.item_is_convertible = M), V && (f.section = V), z && (f.analytics_tags = z), G && (f.sl_campaign_id = G), B && (f.sl_campaign_owner = B), this.requests.queue("".concat(n).concat(x(f, this.options)), void 0, void 0, w), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send conversion event to API
       *
       * @function trackConversion
       * @param {string} [term] - Search results query term that led to conversion event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {number} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User performed an action indicating interest in an item (add to cart, add to wishlist, etc.)
       * @see https://docs.constructor.com/docs/integrating-with-constructor-behavioral-tracking-data-driven-event-tracking
       * @example
       * constructorio.tracker.trackConversion(
       *     'T-Shirt',
       *     {
       *         itemId: 'KMH876',
       *         revenue: 12.00,
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *         type: 'like',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackConversion",
      value: function(e, t) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (t && (0, a.default)(t) === "object" && !Array.isArray(t)) {
          var n = e || "TERM_UNKNOWN", f = "".concat(this.options.serviceUrl, "/v2/behavioral_action/conversion?"), S = {}, l = {}, o = t.name, r = t.item_name, d = t.itemName, c = d === void 0 ? r || o : d, b = t.customer_id, k = t.customerId, A = k === void 0 ? b : k, O = t.item_id, N = t.itemId, U = N === void 0 ? O || A : N, I = t.variation_id, P = t.variationId, L = P === void 0 ? I : P, D = t.revenue, j = t.section, F = j === void 0 ? "Products" : j, M = t.display_name, V = t.displayName, z = V === void 0 ? M : V, B = t.type, G = t.is_custom_type, H = t.isCustomType, W = H === void 0 ? G : H;
          U && (l.item_id = U), c && (l.item_name = c), L && (l.variation_id = L), (D || D === 0) && (l.revenue = D.toString()), F && (S.section = F, l.section = F), n && (l.search_term = n), B && (l.type = B), W && (l.is_custom_type = W), z && (l.display_name = z);
          var Y = "".concat(f).concat(x(S, this.options)), re = "POST", K = m(l, u(u({}, this.options), {}, {
            requestMethod: re
          }));
          return this.requests.queue(Y, re, K, w), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send purchase event to API
       *
       * @function trackPurchase
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {Array.<{itemId: string | undefined,
       * variationId: string | undefined,
       * itemName: string | undefined,
       * count: number | undefined,
       * price: number | undefined}>} parameters.items - List of product item objects
       * @param {number} parameters.revenue - The subtotal (excluding taxes, shipping, etc.) of the entire order
       * @param {string} [parameters.orderId] - Unique order identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User completed an order (usually fired on order confirmation page)
       * @example
       * constructorio.tracker.trackPurchase(
       *     {
       *         items: [{ itemId: 'KMH876', price: 1, count: 1}, { itemId: 'KMH140', price: 1, count: 1s }],
       *         revenue: 12.00,
       *         orderId: 'OUNXBG2HMA',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackPurchase",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/purchase?"), n = {}, f = {}, S = e.items, l = e.revenue, o = e.order_id, r = e.orderId, d = r === void 0 ? o : r, c = e.section, b = e.analyticsTags, k = this.options.apiKey;
          if (d) {
            if (s.hasOrderIdRecord({
              orderId: d,
              apiKey: k
            }))
              return !1;
            s.addOrderIdRecord({
              orderId: d,
              apiKey: k
            }), f.order_id = d;
          }
          S && Array.isArray(S) && (f.items = S.slice(0, 100).map(function(U) {
            return s.toSnakeCaseKeys(U, !1);
          })), (l || l === 0) && (f.revenue = l), c ? n.section = c : n.section = "Products", b && (f.analytics_tags = b);
          var A = "".concat(w).concat(x(n, this.options)), O = "POST", N = m(f, u(u({}, this.options), {}, {
            requestMethod: O
          }));
          return this.requests.queue(A, O, N, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation view event to API
       *
       * @function trackRecommendationView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.podId - Pod identifier
       * @param {number} parameters.numResultsViewed - Number of results viewed
       * @param {object[]} [parameters.items] - List of Product Item Objects
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {string} [parameters.section="Products"] - Results section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a set of recommendations
       * @example
       * constructorio.tracker.trackRecommendationView(
       *     {
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         podId: '019927c2-f955-4020',
       *         numResultsViewed: 3,
       *     },
       * );
       */
    }, {
      key: "trackRecommendationView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_view?"), n = {}, f = e.result_count, S = e.result_page, l = e.resultPage, o = l === void 0 ? S : l, r = e.result_id, d = e.resultId, c = d === void 0 ? r : d, b = e.section, k = e.url, A = e.pod_id, O = e.podId, N = O === void 0 ? A : O, U = e.num_results_viewed, I = e.numResultsViewed, P = I === void 0 ? U : I, L = e.items, D = e.analyticsTags, j = e.seedItemIds, F = e.resultCount, M = F === void 0 ? f || L?.length || 0 : F;
          s.isNil(M) || (n.result_count = M), s.isNil(o) || (n.result_page = o), c && (n.result_id = c), b ? n.section = b : n.section = "Products", k && (n.url = s.truncateString(k, E)), N && (n.pod_id = N), s.isNil(P) || (n.num_results_viewed = P), L && Array.isArray(L) && (n.items = L.slice(0, 100).map(function(G) {
            return s.toSnakeCaseKeys(G, !1);
          })), D && (n.analytics_tags = D), typeof j == "number" ? n.seed_item_ids = [String(j)] : j != null && j.length && typeof j == "string" ? n.seed_item_ids = [j] : j != null && j.length && Array.isArray(j) && (n.seed_item_ids = j);
          var V = "".concat(w).concat(x({}, this.options)), z = "POST", B = m(n, u(u({}, this.options), {}, {
            requestMethod: z
          }));
          return this.requests.queue(V, z, B, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send media impression view event to API
       *
       * @function trackMediaImpressionView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.bannerAdId - Banner ad identifier
       * @param {string} parameters.placementId - Placement identifier
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a media banner
       * @example
       * constructorio.tracker.trackMediaImpressionView(
       *     {
       *         bannerAdId: 'banner_ad_id',
       *         placementId: 'placement_id',
       *     },
       * );
       */
    }, {
      key: "trackMediaImpressionView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = new URL(this.options.mediaServiceUrl);
          w.hostname.startsWith("behavior") || (w.hostname = "behavior.".concat(w.hostname));
          var n = "".concat(w.toString(), "v2/ad_behavioral_action/display_ad_view?"), f = {}, S = e.bannerAdId, l = e.placementId, o = e.analyticsTags;
          s.isNil(S) || (f.banner_ad_id = S), s.isNil(l) || (f.placement_id = l), s.isNil(o) || (f.analytics_tags = o);
          var r = "".concat(n).concat(x({}, this.options)), d = "POST", c = m(f, u(u({}, this.options), {}, {
            requestMethod: d
          }));
          return this.requests.queue(r, d, c, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation click event to API
       *
       * @function trackRecommendationClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.podId - Pod identifier
       * @param {string} parameters.strategyId - Strategy identifier
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of result on page
       * @param {number} [parameters.numResultsPerPage] - Number of results on page
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @returns {(true|Error)}
       * @description User clicked an item that appeared within a list of recommended results
       * @example
       * constructorio.tracker.trackRecommendationClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         podId: '019927c2-f955-4020',
       *         strategyId: 'complimentary',
       *         itemId: 'KMH876',
       *         itemName: 'Socks',
       *         seedItemIds: ['item-123', 'item-456'],
       *     },
       * );
       */
    }, {
      key: "trackRecommendationClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_click?"), n = {}, f = e.variation_id, S = e.variationId, l = S === void 0 ? f : S, o = e.section, r = o === void 0 ? "Products" : o, d = e.result_id, c = e.resultId, b = c === void 0 ? d : c, k = e.result_count, A = e.resultCount, O = A === void 0 ? k : A, N = e.result_page, U = e.resultPage, I = U === void 0 ? N : U, P = e.result_position_on_page, L = e.resultPositionOnPage, D = L === void 0 ? P : L, j = e.num_results_per_page, F = e.numResultsPerPage, M = F === void 0 ? j : F, V = e.pod_id, z = e.podId, B = z === void 0 ? V : z, G = e.strategy_id, H = e.strategyId, W = H === void 0 ? G : H, Y = e.item_id, re = e.itemId, K = re === void 0 ? Y : re, ae = e.item_name, te = e.itemName, oe = te === void 0 ? ae : te, ue = e.analyticsTags, Z = e.slCampaignId, de = e.slCampaignOwner, ee = e.seedItemIds;
          l && (n.variation_id = l), r && (n.section = r), b && (n.result_id = b), s.isNil(O) || (n.result_count = O), s.isNil(I) || (n.result_page = I), s.isNil(D) || (n.result_position_on_page = D), s.isNil(M) || (n.num_results_per_page = M), B && (n.pod_id = B), W && (n.strategy_id = W), K && (n.item_id = K), oe && (n.item_name = oe), ue && (n.analytics_tags = ue), Z && (n.sl_campaign_id = Z), de && (n.sl_campaign_owner = de), typeof ee == "number" ? n.seed_item_ids = [String(ee)] : ee != null && ee.length && typeof ee == "string" ? n.seed_item_ids = [ee] : ee != null && ee.length && Array.isArray(ee) && (n.seed_item_ids = ee);
          var ye = "".concat(w).concat(x({}, this.options)), ve = "POST", we = m(n, u(u({}, this.options), {}, {
            requestMethod: ve
          }));
          return this.requests.queue(ye, ve, we, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse results loaded event to API
       *
       * @function trackBrowseResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section="Products"] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultsLoaded(
       *     {
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_load?"), f = {}, S = e.section, l = S === void 0 ? "Products" : S, o = e.result_count, r = e.result_page, d = e.resultPage, c = d === void 0 ? r : d, b = e.result_id, k = e.resultId, A = k === void 0 ? b : k, O = e.selected_filters, N = e.selectedFilters, U = N === void 0 ? O : N, I = e.url, P = e.sort_order, L = e.sortOrder, D = L === void 0 ? P : L, j = e.sort_by, F = e.sortBy, M = F === void 0 ? j : F, V = e.filter_name, z = e.filterName, B = z === void 0 ? V : z, G = e.filter_value, H = e.filterValue, W = H === void 0 ? G : H, Y = e.items, re = e.analyticsTags, K = e.resultCount, ae = K === void 0 ? (w = o ?? Y?.length) !== null && w !== void 0 ? w : 0 : K;
          l && (f.section = l), s.isNil(ae) || (f.result_count = ae), s.isNil(c) || (f.result_page = c), A && (f.result_id = A), U && (f.selected_filters = U), I && (f.url = s.truncateString(I, E)), D && (f.sort_order = D), M && (f.sort_by = M), B && (f.filter_name = B), W && (f.filter_value = W), Y && Array.isArray(Y) && (f.items = Y.slice(0, 100).map(function(Z) {
            return s.toSnakeCaseKeys(Z, !1);
          })), re && (f.analytics_tags = re);
          var te = "".concat(n).concat(x({}, this.options)), oe = "POST", ue = m(f, u(u({}, this.options), {}, {
            requestMethod: oe
          }));
          return this.requests.queue(te, oe, ue, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse result click event to API
       *
       * @function trackBrowseResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [parameters.selectedFilters] -  Selected filters
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         itemId: 'KMH876',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_click?"), n = {}, f = e.section, S = f === void 0 ? "Products" : f, l = e.variation_id, o = e.variationId, r = o === void 0 ? l : o, d = e.result_id, c = e.resultId, b = c === void 0 ? d : c, k = e.result_count, A = e.resultCount, O = A === void 0 ? k : A, N = e.result_page, U = e.resultPage, I = U === void 0 ? N : U, P = e.result_position_on_page, L = e.resultPositionOnPage, D = L === void 0 ? P : L, j = e.num_results_per_page, F = e.numResultsPerPage, M = F === void 0 ? j : F, V = e.selected_filters, z = e.selectedFilters, B = z === void 0 ? V : z, G = e.filter_name, H = e.filterName, W = H === void 0 ? G : H, Y = e.filter_value, re = e.filterValue, K = re === void 0 ? Y : re, ae = e.customer_id, te = e.customerId, oe = te === void 0 ? ae : te, ue = e.item_id, Z = e.itemId, de = Z === void 0 ? oe || ue : Z, ee = e.item_name, ye = e.name, ve = e.itemName, we = ve === void 0 ? ee || ye : ve, Me = e.analyticsTags, ze = e.slCampaignId, Ue = e.slCampaignOwner;
          S && (n.section = S), r && (n.variation_id = r), b && (n.result_id = b), s.isNil(O) || (n.result_count = O), s.isNil(I) || (n.result_page = I), s.isNil(D) || (n.result_position_on_page = D), s.isNil(M) || (n.num_results_per_page = M), B && (n.selected_filters = B), W && (n.filter_name = W), K && (n.filter_value = K), de && (n.item_id = de), we && (n.item_name = we), Me && (n.analytics_tags = Me), ze && (n.sl_campaign_id = ze), Ue && (n.sl_campaign_owner = Ue);
          var Ge = "".concat(w).concat(x({}, this.options)), xe = "POST", Gr = m(n, u(u({}, this.options), {}, {
            requestMethod: xe
          }));
          return this.requests.queue(Ge, xe, Gr, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse redirect event to API
       * @private
       * @function trackBrowseRedirect
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.searchTerm - The search query that caused redirect
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {string} [parameters.userInput] - The text that a user had typed at the moment when submitting search request
       * @param {string} [parameters.redirectToUrl] - URL of the  page to which user is redirected
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User got redirected to a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseRedirect(
       *     {
       *         searchTerm: "books",
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         redirectToUrl: 'https://demo.constructor.io/books',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *     },
       * );
       */
    }, {
      key: "trackBrowseRedirect",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_redirect?"), n = {}, f = e.searchTerm, S = e.userInput, l = e.section, o = l === void 0 ? "Products" : l, r = e.selectedFilters, d = e.redirectToUrl, c = e.sortOrder, b = e.sortBy, k = e.filterName, A = e.filterValue, O = e.analyticsTags;
          f && (n.search_term = f), S && (n.user_input = S), d && (n.redirect_to_url = d), o && (n.section = o), r && (n.selected_filters = r), c && (n.sort_order = c), b && (n.sort_by = b), k && (n.filter_name = k), A && (n.filter_value = A), O && (n.analytics_tags = O);
          var N = "".concat(w).concat(x({}, this.options)), U = "POST", I = m(n, u(u({}, this.options), {}, {
            requestMethod: U
          }));
          return this.requests.queue(N, U, I, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send generic result click event to API
       *
       * @function trackGenericResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared outside of the scope of search / browse / recommendations
       * @example
       * constructorio.tracker.trackGenericResultClick(
       *     {
       *         itemId: 'KMH876',
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *     },
       * );
       */
    }, {
      key: "trackGenericResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ((0, a.default)(e) === "object") {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/result_click?"), n = {}, f = e.item_id, S = e.itemId, l = S === void 0 ? f : S, o = e.item_name, r = e.itemName, d = r === void 0 ? o : r, c = e.variation_id, b = e.variationId, k = b === void 0 ? c : b, A = e.section, O = A === void 0 ? "Products" : A, N = e.analyticsTags;
          if (l) {
            n.section = O, n.item_id = l, d && (n.item_name = d), k && (n.variation_id = k), N && (n.analytics_tags = N);
            var U = "".concat(w).concat(x({}, this.options)), I = "POST", P = m(n, u(u({}, this.options), {}, {
              requestMethod: I
            }));
            return this.requests.queue(U, I, P, t), this.requests.send(), !0;
          }
        }
        return this.requests.send(), new Error('A parameters object with an "itemId" property is required.');
      }
      /**
       * Send quiz results loaded event to API
       *
       * @function trackQuizResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} parameters.url - Current page url
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultsLoaded(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         url: 'www.example.com',
       *         resultCount: 167,
       *         items: [{ itemId: 'KMH876', itemName: 'coffee' }, { itemId: 'KMH140', variationId: '123' }],
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_load?"), n = e.quiz_id, f = e.quizId, S = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, d = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? d : c, k = e.url, A = e.section, O = A === void 0 ? "Products" : A, N = e.result_count, U = e.resultCount, I = U === void 0 ? N : U, P = e.result_id, L = e.resultId, D = L === void 0 ? P : L, j = e.result_page, F = e.resultPage, M = F === void 0 ? j : F, V = e.items, z = {}, B = {};
          if (V && Array.isArray(V) && (B.items = V.slice(0, 100).map(function(Y) {
            return s.toSnakeCaseKeys(Y, !1);
          })), typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof k != "string")
            return new Error('"url" is a required parameter of type string');
          if (B.quiz_id = S, B.quiz_version_id = r, B.quiz_session_id = b, B.url = s.truncateString(k, E), !s.isNil(O)) {
            if (typeof O != "string")
              return new Error('"section" must be a string');
            z.section = O, B.section = O;
          }
          if (!s.isNil(I)) {
            if (typeof I != "number")
              return new Error('"resultCount" must be a number');
            B.result_count = I;
          }
          if (!s.isNil(D)) {
            if (typeof D != "string")
              return new Error('"resultId" must be a string');
            B.result_id = D;
          }
          if (!s.isNil(M)) {
            if (typeof M != "number")
              return new Error('"resultPage" must be a number');
            B.result_page = M;
          }
          var G = "".concat(w).concat(x(z, this.options)), H = "POST", W = m(B, u(u({}, this.options), {}, {
            requestMethod: H
          }));
          return this.requests.queue(G, H, W, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz result click event to API
       *
       * @function trackQuizResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product variation unique identifier
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultClick(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '123',
       *         itemId: '123',
       *         itemName: 'espresso'
       *         variationId: '733431',
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_click?"), n = e.quiz_id, f = e.quizId, S = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, d = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? d : c, k = e.item_id, A = e.itemId, O = A === void 0 ? k : A, N = e.item_name, U = e.itemName, I = U === void 0 ? N : U, P = e.result_count, L = e.resultCount, D = L === void 0 ? P : L, j = e.result_id, F = e.resultId, M = F === void 0 ? j : F, V = e.result_page, z = e.resultPage, B = z === void 0 ? V : z, G = e.num_results_per_page, H = e.numResultsPerPage, W = H === void 0 ? G : H, Y = e.result_position_on_page, re = e.resultPositionOnPage, K = re === void 0 ? Y : re, ae = e.section, te = ae === void 0 ? "Products" : ae, oe = e.variationId, ue = {}, Z = {};
          if (typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof I != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (Z.quiz_id = S, Z.quiz_version_id = r, Z.quiz_session_id = b, !s.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            Z.item_id = O;
          }
          if (!s.isNil(I)) {
            if (typeof I != "string")
              return new Error('"itemName" must be a string');
            Z.item_name = I;
          }
          if (!s.isNil(oe)) {
            if (typeof oe != "string")
              return new Error('"variationId" must be a string');
            Z.variation_id = oe;
          }
          if (!s.isNil(te)) {
            if (typeof te != "string")
              return new Error('"section" must be a string');
            ue.section = te;
          }
          if (!s.isNil(D)) {
            if (typeof D != "number")
              return new Error('"resultCount" must be a number');
            Z.result_count = D;
          }
          if (!s.isNil(M)) {
            if (typeof M != "string")
              return new Error('"resultId" must be a string');
            Z.result_id = M;
          }
          if (!s.isNil(B)) {
            if (typeof B != "number")
              return new Error('"resultPage" must be a number');
            Z.result_page = B;
          }
          if (!s.isNil(W)) {
            if (typeof W != "number")
              return new Error('"numResultsPerPage" must be a number');
            Z.num_results_per_page = W;
          }
          if (!s.isNil(K)) {
            if (typeof K != "number")
              return new Error('"resultPositionOnPage" must be a number');
            Z.result_position_on_page = K;
          }
          var de = "".concat(w).concat(x(ue, this.options)), ee = "POST", ye = m(Z, u(u({}, this.options), {}, {
            requestMethod: ee
          }));
          return this.requests.queue(de, ee, ye, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz conversion event to API
       *
       * @function trackQuizConversion
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.section='Products'] - Index section
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizConversion(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         itemName: 'espresso',
       *         variationId: '167',
       *         type: 'add_to_cart',
       *         revenue: '1.0'
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizConversion",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_conversion?"), n = e.quiz_id, f = e.quizId, S = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, d = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? d : c, k = e.item_id, A = e.itemId, O = A === void 0 ? k : A, N = e.item_name, U = e.itemName, I = U === void 0 ? N : U, P = e.variation_id, L = e.variationId, D = L === void 0 ? P : L, j = e.revenue, F = e.section, M = F === void 0 ? "Products" : F, V = e.type, z = e.is_custom_type, B = e.isCustomType, G = B === void 0 ? z : B, H = e.display_name, W = e.displayName, Y = W === void 0 ? H : W, re = {}, K = {};
          if (typeof S != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof I != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (K.quiz_id = S, K.quiz_version_id = r, K.quiz_session_id = b, !s.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            K.item_id = O;
          }
          if (!s.isNil(I)) {
            if (typeof I != "string")
              return new Error('"itemName" must be a string');
            K.item_name = I;
          }
          if (!s.isNil(D)) {
            if (typeof D != "string")
              return new Error('"variationId" must be a string');
            K.variation_id = D;
          }
          if (!s.isNil(j)) {
            if (typeof j != "string")
              return new Error('"revenue" must be a string');
            K.revenue = j;
          }
          if (!s.isNil(M)) {
            if (typeof M != "string")
              return new Error('"section" must be a string');
            K.section = M;
          }
          if (!s.isNil(V)) {
            if (typeof V != "string")
              return new Error('"type" must be a string');
            K.type = V;
          }
          if (!s.isNil(G)) {
            if (typeof G != "boolean")
              return new Error('"isCustomType" must be a boolean');
            K.is_custom_type = G;
          }
          if (!s.isNil(Y)) {
            if (typeof Y != "string")
              return new Error('"displayName" must be a string');
            K.display_name = Y;
          }
          var ae = "".concat(w).concat(x(re, this.options)), te = "POST", oe = m(K, u(u({}, this.options), {}, {
            requestMethod: te
          }));
          return this.requests.queue(ae, te, oe, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @function trackAgentSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an agent search
       *   (pressing enter within agent input element, or clicking agent submit element)
       * @example
       * constructorio.tracker.trackAgentSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAgentSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_submit?"), n = e.section, f = e.intent, S = {
            intent: f,
            section: n
          }, l = "".concat(w).concat(x({}, this.options)), o = "POST", r = m(S, u(u({}, this.options), {}, {
            requestMethod: o
          }));
          return this.requests.queue(l, o, r, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load started
       *
       * @function trackAgentResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAgentResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_start?"), n = e.section, f = e.intentResultId, S = e.intent, l = {
            intent_result_id: f,
            intent: S,
            section: n
          }, o = "".concat(w).concat(x({}, this.options)), r = "POST", d = m(l, u(u({}, this.options), {}, {
            requestMethod: r
          }));
          return this.requests.queue(o, r, d, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load finished
       *
       * @function trackAgentResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load finished
       * @example
       * constructorio.tracker.trackAgentResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_finish?"), n = e.section, f = e.searchResultCount, S = e.intentResultId, l = e.intent, o = {
            intent_result_id: S,
            section: n,
            intent: l,
            search_result_count: f
          }, r = "".concat(w).concat(x({}, this.options)), d = "POST", c = m(o, u(u({}, this.options), {}, {
            requestMethod: d
          }));
          return this.requests.queue(r, d, c, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent result click event to API
       *
       * @function trackAgentResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an agent search result
       * @example
       * constructorio.tracker.trackAgentResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_click?"), n = e.section, f = n === void 0 ? "Products" : n, S = e.variationId, l = e.intentResultId, o = e.searchResultId, r = e.itemId, d = e.itemName, c = e.intent, b = {
            section: f,
            variation_id: S,
            intent_result_id: l,
            search_result_id: o,
            item_id: r,
            item_name: d,
            intent: c
          }, k = "".concat(w).concat(x({}, this.options)), A = "POST", O = m(b, u(u({}, this.options), {}, {
            requestMethod: A
          }));
          return this.requests.queue(k, A, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent search result view event to API
       *
       * @function trackAgentResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an agent result
       * @example
       * constructorio.tracker.trackAgentResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAgentResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_view?"), n = e.section, f = n === void 0 ? "Products" : n, S = e.items, l = e.numResultsViewed, o = e.intentResultId, r = e.searchResultId, d = e.intent, c = {
            section: f,
            intent_result_id: o,
            search_result_id: r,
            num_results_viewed: l,
            items: S && Array.isArray(S) && S.slice(0, 100).map(function(O) {
              return s.toSnakeCaseKeys(O, !1);
            }),
            intent: d
          }, b = "".concat(w).concat(x({}, this.options)), k = "POST", A = m(c, u(u({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(b, k, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA search submitted event
       *
       * @function trackAgentSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted agent search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative agent search result search term
       * @example
       * constructorio.tracker.trackAgentSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAgentSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_submit?"), n = e.section, f = e.intent, S = e.searchTerm, l = e.searchResultId, o = e.intentResultId, r = {
            intent: f,
            section: n,
            search_term: S,
            search_result_id: l,
            intent_result_id: o
          }, d = "".concat(w).concat(x({}, this.options)), c = "POST", b = m(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(d, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSubmit instead.
       * @function trackAssistantSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an assistant search
       *   (pressing enter within assistant input element, or clicking assistant submit element)
       * @example
       * constructorio.tracker.trackAssistantSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSubmit(e, t);
      }
      /**
       * Send assistant results page load started
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadStarted instead.
       * @function trackAssistantResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAssistantResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadStarted(e, t);
      }
      /**
       * Send assistant results page load finished
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadFinished instead.
       * @function trackAssistantResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load finished
       * @example
       * constructorio.tracker.trackAssistantResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadFinished(e, t);
      }
      /**
       * Send assistant result click event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultClick instead.
       * @function trackAssistantResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an assistant search result
       * @example
       * constructorio.tracker.trackAssistantResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultClick(e, t);
      }
      /**
       * Send assistant search result view event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultView instead.
       * @function trackAssistantResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an assistant result
       * @example
       * constructorio.tracker.trackAssistantResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultView(e, t);
      }
      /**
       * Send ASA search submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSearchSubmit instead.
       * @function trackAssistantSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted assistant search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative assistant search result search term
       * @example
       * constructorio.tracker.trackAssistantSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSearchSubmit(e, t);
      }
      /**
       * Send product insights agent view events
       *
       * @function trackProductInsightsAgentViews
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {array.<{start: string | undefined,
       * end: string | undefined}>} parameters.viewTimespans - List of timestamp pairs in ISO_8601 format
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentViews({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *     'viewTimespans': [
       *       {
       *         'start': '2025-05-19T14:30:00+02:00',
       *         'end': '2025-05-19T14:30:05+02:00'
       *       },
       *       {
       *         'start': '2025-05-19T14:30:10+02:00',
       *         'end': '2025-05-19T14:30:15+02:00'
       *       }
       *     ]
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentViews",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_views?"), n = e.section, f = e.questions, S = e.itemId, l = e.itemName, o = e.variationId, r = e.viewTimespans, d = {}, c = {
            questions: f,
            item_id: S,
            item_name: l,
            variation_id: o,
            view_timespans: r
          };
          n && (d.section = n);
          var b = "".concat(w).concat(x(d, this.options)), k = "POST", A = m(c, u(u({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(b, k, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent view event
       *
       * @function trackProductInsightsAgentView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_view?"), n = e.section, f = e.questions, S = e.itemId, l = e.itemName, o = e.variationId, r = {}, d = {
            questions: f,
            item_id: S,
            item_name: l,
            variation_id: o
          };
          n && (r.section = n);
          var c = "".concat(w).concat(x(r, this.options)), b = "POST", k = m(d, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent out of view event
       *
       * @function trackProductInsightsAgentOutOfView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element disappeared from the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentOutOfView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentOutOfView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_out_of_view?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = {}, r = {
            item_id: f,
            item_name: S,
            variation_id: l
          };
          n && (o.section = n);
          var d = "".concat(w).concat(x(o, this.options)), c = "POST", b = m(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(d, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent input focus event
       *
       * @function trackProductInsightsAgentFocus
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on the product insights agent input element
       * @example
       * constructorio.tracker.trackProductInsightsAgentFocus({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentFocus",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_focus?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = {}, r = {
            item_id: f,
            item_name: S,
            variation_id: l
          };
          n && (o.section = n);
          var d = "".concat(w).concat(x(o, this.options)), c = "POST", b = m(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(d, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question click event
       *
       * @function trackProductInsightsAgentQuestionClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user clicked on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked on a question within the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionClick({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_click?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = e.question, r = {}, d = {
            item_id: f,
            item_name: S,
            variation_id: l,
            question: o
          };
          n && (r.section = n);
          var c = "".concat(w).concat(x(r, this.options)), b = "POST", k = m(d, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question submit event
       *
       * @function trackProductInsightsAgentQuestionSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a question to the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionSubmit({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Tell me some key highlights about this item?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_submit?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = e.question, r = {}, d = {
            item_id: f,
            item_name: S,
            variation_id: l,
            question: o
          };
          n && (r.section = n);
          var c = "".concat(w).concat(x(r, this.options)), b = "POST", k = m(d, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, k, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer view event
       *
       * @function trackProductInsightsAgentAnswerView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} parameters.answerText - Answer text of the question
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed the answer provided by the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?',
       *     'answerText': 'This product is awesome!',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_view?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = e.question, r = e.answerText, d = e.qnaResultId, c = {}, b = {
            item_id: f,
            item_name: S,
            variation_id: l,
            question: o,
            answer_text: r,
            qna_result_id: d
          };
          n && (c.section = n);
          var k = "".concat(w).concat(x(c, this.options)), A = "POST", O = m(b, u(u({}, this.options), {}, {
            requestMethod: A
          }));
          return this.requests.queue(k, A, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer feedback event
       *
       * @function trackProductInsightsAgentAnswerFeedback
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.feedbackLabel - Feedback value: either "thumbs_up" or "thumbs_down"
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description A user provided feedback on an answers usefulness
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerFeedback({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'feedbackLabel': 'thumbs_up',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerFeedback",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, a.default)(e) === "object" && !Array.isArray(e)) {
          var w = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_feedback?"), n = e.section, f = e.itemId, S = e.itemName, l = e.variationId, o = e.feedbackLabel, r = e.qnaResultId, d = {}, c = {
            item_id: f,
            item_name: S,
            variation_id: l,
            feedback_label: o,
            qna_result_id: r
          };
          n && (d.section = n);
          var b = "".concat(w).concat(x(d, this.options)), k = "POST", A = m(c, u(u({}, this.options), {}, {
            requestMethod: k
          }));
          return this.requests.queue(b, k, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Subscribe to success or error messages emitted by tracking requests
       *
       * @function on
       * @param {string} messageType - Type of message to listen for ('success' or 'error')
       * @param {function} callback - Callback to be invoked when message received
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.on('error', (data) => {
       *     // Handle tracking error
       * });
       */
    }, {
      key: "on",
      value: function(e, t) {
        return e !== "success" && e !== "error" ? new Error('messageType must be a string of value "success" or "error"') : !t || typeof t != "function" ? new Error("callback is required and must be a function") : (this.eventemitter.on(e, t), !0);
      }
    }]);
  })();
  return C.RequestQueue = R, ht = C, ht;
}
var gt = {}, kr;
function Ni() {
  return kr || (kr = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0, i.default = "2.70.0";
  })(gt)), gt;
}
var _t = { exports: {} }, pt = { exports: {} }, yt = { exports: {} }, Sr;
function Jr() {
  return Sr || (Sr = 1, (function(i) {
    function a(y, v) {
      (v == null || v > y.length) && (v = y.length);
      for (var _ = 0, h = Array(v); _ < v; _++) h[_] = y[_];
      return h;
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(yt)), yt.exports;
}
var qr;
function Ui() {
  return qr || (qr = 1, (function(i) {
    var a = Jr();
    function y(v) {
      if (Array.isArray(v)) return a(v);
    }
    i.exports = y, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(pt)), pt.exports;
}
var wt = { exports: {} }, Er;
function Di() {
  return Er || (Er = 1, (function(i) {
    function a(y) {
      if (typeof Symbol < "u" && y[Symbol.iterator] != null || y["@@iterator"] != null) return Array.from(y);
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(wt)), wt.exports;
}
var bt = { exports: {} }, Rr;
function Pi() {
  return Rr || (Rr = 1, (function(i) {
    var a = Jr();
    function y(v, _) {
      if (v) {
        if (typeof v == "string") return a(v, _);
        var h = {}.toString.call(v).slice(8, -1);
        return h === "Object" && v.constructor && (h = v.constructor.name), h === "Map" || h === "Set" ? Array.from(v) : h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h) ? a(v, _) : void 0;
      }
    }
    i.exports = y, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(bt)), bt.exports;
}
var mt = { exports: {} }, xr;
function Li() {
  return xr || (xr = 1, (function(i) {
    function a() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(mt)), mt.exports;
}
var Cr;
function ji() {
  return Cr || (Cr = 1, (function(i) {
    var a = Ui(), y = Di(), v = Pi(), _ = Li();
    function h(u) {
      return a(u) || y(u) || v(u) || _();
    }
    i.exports = h, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(_t)), _t.exports;
}
var kt, Ar;
function Bi() {
  if (Ar) return kt;
  Ar = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = i(ji()), _ = i(Re()), h = Ne(), u = he();
  function g(R, E, m, x) {
    var C = m.apiKey, q = m.clientId, p = m.sessionId, e = m.segments, t = m.userId, w = m.version, n = m.quizzesServiceUrl, f = {
      c: w
    }, S = "";
    if (f.key = C, f.i = q, f.s = p, e && e.length && (f.us = e), t && (f.ui = String(t)), !R || typeof R != "string")
      throw new Error("quizId is a required parameter of type string");
    if (x === "results" && ((0, _.default)(E.answers) !== "object" || !Array.isArray(E.answers) || E.answers.length === 0))
      throw new Error("answers is a required parameter of type array");
    if (E) {
      var l = E.section, o = E.answers, r = E.quizSessionId, d = E.quizVersionId, c = E.page, b = E.resultsPerPage, k = E.filters, A = E.fmtOptions, O = E.hiddenFields;
      l && (f.section = l), d && (f.quiz_version_id = d), r && (f.quiz_session_id = r), o && o.length && (S = "&".concat(u.stringify({
        a: o.map(function(U) {
          return (0, v.default)(U.map(encodeURIComponent)).join(",");
        })
      }))), u.isNil(c) || (f.page = c), u.isNil(b) || (f.num_results_per_page = b), k && (f.filters = k), A && (f.fmt_options = A), O && (f.fmt_options ? f.fmt_options.hidden_fields = O : f.fmt_options = {
        hidden_fields: O
      });
    }
    f._dt = Date.now(), f = u.cleanParams(f);
    var N = u.stringify(f);
    return "".concat(n, "/v1/quizzes/").concat(encodeURIComponent(R), "/").concat(encodeURIComponent(x), "/?").concat(N).concat(S);
  }
  var s = /* @__PURE__ */ (function() {
    function R(E) {
      (0, a.default)(this, R), this.options = E || {}, this.eventDispatcher = new h(E.eventDispatcher);
    }
    return (0, y.default)(R, [{
      key: "getQuizNextQuestion",
      value: function(m, x) {
        var C = this, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p, e = this.options.fetch, t = new AbortController(), w = t.signal;
        try {
          p = g(m, x, this.options, "next");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, q, t), e(p, {
          signal: w
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizNextQuestion.completed", n), n;
          throw new Error("getQuizNextQuestion response data is malformed");
        });
      }
      /**
       * Retrieves filter expression and recommendation URL from given answers
       *
       * @function getQuizResults
       * @description Retrieve quiz recommendation and filter expression from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters to refine result set
       * @param {array} parameters.answers - An array of answers in the format [[1,2], [1], ["true"], ["seen"], [""]]. Based on the question type, answers should either be an integer, "true"/"false", "seen" or an empty string ("") if skipped
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {string} [parameters.quizSessionId] - Session identifier for the quiz. Session ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {number} [parameters.page] - The page number of the results
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Key / value mapping (dictionary) of filters used to refine results
       * @param {object} [parameters.fmtOptions] - Key / value mapping (dictionary) of options used for result formatting
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-quizzes-get-quiz-results
       * @example
       * constructorio.quizzes.getQuizResults('quizId', {
       *    answers: [[1,2],[1]],
       *    section: '123',
       *    quizVersionId: '123',
       *    quizSessionId: '234'
       * });
       */
    }, {
      key: "getQuizResults",
      value: function(m, x) {
        var C = this, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p, e = this.options.fetch, t = new AbortController(), w = t.signal;
        try {
          p = g(m, x, this.options, "results");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, q, t), e(p, {
          signal: w
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizResults.completed", n), n;
          throw new Error("getQuizResults response data is malformed");
        });
      }
      /**
       * Retrieves configuration for the results page of a particular quiz
       *
       * @function getQuizResultsConfig
       * @description Retrieve quiz results page configuration from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @example
       * constructorio.quizzes.getQuizResultsConfig('quizId', {
       *    quizVersionId: '123',
       * });
       */
    }, {
      key: "getQuizResultsConfig",
      value: function(m, x) {
        var C = this, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p, e = this.options.fetch, t = new AbortController(), w = t.signal;
        try {
          p = g(m, x, this.options, "results_config");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, q, t), e(p, {
          signal: w
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizResultsConfig.completed", n), n;
          throw new Error("getQuizResultsConfig response data is malformed");
        });
      }
      /**
       * Retrieves all questions for a particular quiz
       *
       * @function getQuizAllQuestions
       * @description Retrieve all questions for a particular quiz from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {object} parameters - Additional parameters
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {string} [parameters.quizSessionId] - Session identifier for the quiz. Session ID will be returned with the first request or with getQuizResultsConfig and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @example
       * constructorio.quizzes.getQuizAllQuestions('quizId', {
       *    quizVersionId: '123',
       * });
       */
    }, {
      key: "getQuizAllQuestions",
      value: function(m, x) {
        var C = this, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, p, e = this.options.fetch, t = new AbortController(), w = t.signal;
        try {
          p = g(m, x, this.options, "all_questions");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, q, t), e(p, {
          signal: w
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return C.eventDispatcher.queue("quizzes.getQuizAllQuestions.completed", n), n;
          throw new Error("getQuizAllQuestions response data is malformed");
        });
      }
    }]);
  })();
  return kt = s, kt;
}
var De = { exports: {} }, Or;
function Ft() {
  if (Or) return De.exports;
  Or = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = i(Ke()), _ = he(), h = _.cleanParams, u = _.trimNonBreakingSpaces, g = _.encodeURIComponentRFC3986, s = _.stringify;
  function R(x, C, q) {
    var p = q.apiKey, e = q.version, t = q.sessionId, w = q.clientId, n = q.userId, f = q.segments, S = q.testCells, l = q.agentServiceUrl, o = q.assistantServiceUrl, r = {
      c: e
    };
    r.key = p, r.i = w, r.s = t;
    var d = l || o;
    if (!x || typeof x != "string")
      throw new Error("intent is a required parameter of type string");
    if (!C.domain || typeof C.domain != "string")
      throw new Error("parameters.domain is a required parameter of type string");
    if (S && Object.keys(S).forEach(function(O) {
      r["ef-".concat(O)] = S[O];
    }), f && f.length && (r.us = f), n && (r.ui = String(n)), C) {
      var c = C.domain, b = C.numResultsPerPage;
      c && (r.domain = c), b && (r.num_results_per_page = b);
    }
    r._dt = Date.now(), r = h(r);
    var k = s(r), A = x.replace(/^\//, "|");
    return "".concat(d, "/v1/intent/").concat(g(u(A)), "?").concat(k);
  }
  function E(x, C, q) {
    var p = function(t) {
      x.addEventListener(t, function(w) {
        var n = JSON.parse(w.data);
        C.enqueue({
          type: t,
          data: n
        });
      });
    };
    Object.values(q).forEach(function(e) {
      e !== q.END && p(e);
    }), x.addEventListener(q.END, function() {
      C.close(), x.close();
    }), x.onerror = function(e) {
      C.error(e), x.close();
    };
  }
  var m = /* @__PURE__ */ (function() {
    function x(C) {
      (0, a.default)(this, x), this.options = C || {};
    }
    return (0, y.default)(x, [{
      key: "getAgentResultsStream",
      value: (
        /**
         * Retrieve agent results from EventStream
         *
         * @function getAgentResultsStream
         * @description Retrieve a stream of agent results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} [parameters] - Additional parameters to refine result set
         * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
         * @param {number} [parameters.numResultsPerPage] - The total number of results to return
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.agent.getAgentResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(q, p) {
          var e, t;
          try {
            var w = R(q, p, this.options);
            e = new EventSource(w), t = new ReadableStream({
              // To be called on stream start
              start: function(l) {
                E(e, l, x.EventTypes);
              },
              // To be called on stream cancelling
              cancel: function() {
                e.close();
              }
            });
          } catch (S) {
            if (t) {
              var n;
              (n = t) === null || n === void 0 || n.cancel();
            } else {
              var f;
              (f = e) === null || f === void 0 || f.close();
            }
            throw new Error(S.message);
          }
          return t;
        }
      )
    }]);
  })();
  return (0, v.default)(m, "EventTypes", {
    START: "start",
    // Denotes the start of the stream
    GROUP: "group",
    // Represents a semantic grouping of search results, optionally having textual explanation
    SEARCH_RESULT: "search_result",
    // Represents a set of results with metadata (used to show results with search refinements)
    ARTICLE_REFERENCE: "article_reference",
    // Represents a set of content with metadata
    RECIPE_INFO: "recipe_info",
    // Represents recipes' auxiliary information like cooking times & serving sizes
    RECIPE_INSTRUCTIONS: "recipe_instructions",
    // Represents recipe instructions
    SERVER_ERROR: "server_error",
    // Server Error event
    IMAGE_META: "image_meta",
    // This event type is used for enhancing recommendations with media content such as images
    END: "end"
    // Represents the end of data stream
  }), De.exports = m, De.exports.createAgentUrl = R, De.exports.setupEventListeners = E, De.exports;
}
var Pe = { exports: {} }, St = { exports: {} }, qt = { exports: {} }, Tr;
function Fi() {
  return Tr || (Tr = 1, (function(i) {
    function a(y) {
      if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return y;
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(qt)), qt.exports;
}
var Ir;
function Mi() {
  return Ir || (Ir = 1, (function(i) {
    var a = Re().default, y = Fi();
    function v(_, h) {
      if (h && (a(h) == "object" || typeof h == "function")) return h;
      if (h !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return y(_);
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(St)), St.exports;
}
var Et = { exports: {} }, Nr;
function zi() {
  return Nr || (Nr = 1, (function(i) {
    function a(y) {
      return i.exports = a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, i.exports.__esModule = !0, i.exports.default = i.exports, a(y);
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Et)), Et.exports;
}
var Rt = { exports: {} }, xt = { exports: {} }, Ur;
function Qi() {
  return Ur || (Ur = 1, (function(i) {
    function a(y, v) {
      return i.exports = a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, h) {
        return _.__proto__ = h, _;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, a(y, v);
    }
    i.exports = a, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(xt)), xt.exports;
}
var Dr;
function Vi() {
  return Dr || (Dr = 1, (function(i) {
    var a = Qi();
    function y(v, _) {
      if (typeof _ != "function" && _ !== null) throw new TypeError("Super expression must either be null or a function");
      v.prototype = Object.create(_ && _.prototype, {
        constructor: {
          value: v,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(v, "prototype", {
        writable: !1
      }), _ && a(v, _);
    }
    i.exports = y, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Rt)), Rt.exports;
}
var Pr;
function Ki() {
  if (Pr) return Pe.exports;
  Pr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = i(Mi()), _ = i(zi()), h = i(Vi()), u = i(Ke());
  function g(q, p, e) {
    return p = (0, _.default)(p), (0, v.default)(q, s() ? Reflect.construct(p, e || [], (0, _.default)(q).constructor) : p.apply(q, e));
  }
  function s() {
    try {
      var q = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (s = function() {
      return !!q;
    })();
  }
  var R = Ft(), E = Ft(), m = E.createAgentUrl, x = E.setupEventListeners, C = /* @__PURE__ */ (function(q) {
    function p() {
      var e;
      (0, a.default)(this, p);
      for (var t = arguments.length, w = new Array(t), n = 0; n < t; n++)
        w[n] = arguments[n];
      return e = g(this, p, [].concat(w)), (0, u.default)(e, "EventTypes", R.EventTypes), e;
    }
    return (0, h.default)(p, q), (0, y.default)(p, [{
      key: "getAssistantResultsStream",
      value: (
        /**
         * Retrieve assistant results from EventStream
         *
         * @deprecated Use getAssistantResultsStream from the Agent module instead.
         * @function getAssistantResultsStream
         * @description Retrieve a stream of assistant results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} [parameters] - Additional parameters to refine result set
         * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
         * @param {number} [parameters.numResultsPerPage] - The total number of results to return
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.assistant.getAssistantResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(t, w) {
          return this.getAgentResultsStream(t, w);
        }
      )
    }]);
  })(R);
  return Pe.exports = C, Pe.exports.createAssistantUrl = m, Pe.exports.setupEventListeners = x, Pe.exports;
}
var Ct, Lr;
function Ji() {
  if (Lr) return Ct;
  Lr = 1;
  var i = fe(), a = i(ge()), y = i(_e()), v = ki(), _ = qi(), h = Ei(), u = Ri(), g = xi(), s = Ii(), R = Ne(), E = he(), m = Ni(), x = m.default, C = Bi(), q = Ft(), p = Ki(), e = function() {
    var n = "ciojs-client-", f = [];
    return E.canUseDOM() || f.push("domless"), typeof process < "u" && typeof process.env < "u" && process.env.BUNDLED && f.push("bundled"), "".concat(n).concat(f.join("-")).concat(f.length ? "-" : "").concat(x);
  }, t = /* @__PURE__ */ (function() {
    function w() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      (0, a.default)(this, w);
      var f = n.apiKey, S = n.version, l = n.serviceUrl, o = n.quizzesServiceUrl, r = n.agentServiceUrl, d = n.assistantServiceUrl, c = n.mediaServiceUrl, b = n.segments, k = n.testCells, A = n.clientId, O = n.sessionId, N = n.userId, U = n.fetch, I = n.trackingSendDelay, P = n.sendReferrerWithTrackingEvents, L = n.sendTrackingEvents, D = n.eventDispatcher, j = n.idOptions, F = n.beaconMode, M = n.networkParameters;
      if (!f || typeof f != "string")
        throw new Error("API key is a required parameter of type string");
      var V, z, B = typeof Gt < "u" && Gt.CLIENT_VERSION;
      if (E.canUseDOM()) {
        var G = new v(j || {});
        V = G.session_id, z = G.client_id;
      } else {
        if (!O || typeof O != "number")
          throw new Error("sessionId is a required user parameter of type number");
        if (!A || typeof A != "string")
          throw new Error("clientId is a required user parameter of type string");
      }
      var H = l && l.replace(/\/$/, "");
      this.options = {
        apiKey: f,
        version: S || B || e(),
        serviceUrl: E.addHTTPSToString(H) || "https://ac.cnstrc.com",
        quizzesServiceUrl: o && o.replace(/\/$/, "") || "https://quizzes.cnstrc.com",
        agentServiceUrl: r && r.replace(/\/$/, "") || "https://agent.cnstrc.com",
        assistantServiceUrl: d && d.replace(/\/$/, "") || "https://assistant.cnstrc.com",
        mediaServiceUrl: c && c.replace(/\/$/, "") || "https://media-cnstrc.com",
        sessionId: O || V,
        clientId: A || z,
        userId: N,
        segments: b,
        testCells: k,
        fetch: U || fetch,
        trackingSendDelay: I,
        sendTrackingEvents: L,
        sendReferrerWithTrackingEvents: P,
        eventDispatcher: D,
        beaconMode: F !== !1,
        // Defaults to 'true',
        networkParameters: M || {}
      }, this.search = new _(this.options), this.browse = new h(this.options), this.autocomplete = new u(this.options), this.recommendations = new g(this.options), this.tracker = new s(this.options), this.quizzes = new C(this.options), this.agent = new q(this.options), this.assistant = new p(this.options), new R(n.eventDispatcher).queue("instantiated", this.options);
    }
    return (0, y.default)(w, [{
      key: "setClientOptions",
      value: function(f) {
        if (Object.keys(f).length) {
          var S = f.apiKey, l = f.segments, o = f.testCells, r = f.sessionId, d = f.userId, c = f.sendTrackingEvents;
          S && (this.options.apiKey = S), l && (this.options.segments = l), o && (this.options.testCells = o), typeof c == "boolean" && (this.options.sendTrackingEvents = c, this.tracker.requests.sendTrackingEvents = c), r && !E.canUseDOM() && (this.options.sessionId = r), "userId" in f && (this.options.userId = d);
        }
      }
    }]);
  })();
  return t.Tracker = s, E.canUseDOM() && (window.ConstructorioClient = t), Ct = t, Ct;
}
var Gi = Ji();
const Hi = /* @__PURE__ */ Hr(Gi), Wi = "1.4.2", Je = (i) => {
  if (!i.apiKey)
    throw new Error("ConstructorIO Api key is required");
  return new Hi({
    sendTrackingEvents: !0,
    version: `cio-ui-plp-${Wi}`,
    ...i
  });
}, sn = (i, a, y) => {
  const v = ne.useMemo(() => Je(i), [i]);
  return Vt({
    queryKey: ["cioRecommendations", a, y],
    placeholderData: zt,
    queryFn: () => v.recommendations.getRecommendations(a, {
      numResults: 8,
      ...y
    }),
    enabled: !!v && !!a
  });
}, an = (i, a, y) => {
  const v = ne.useMemo(() => Je(i), [i]);
  return Vt({
    queryKey: ["cioBrowse", a, y],
    placeholderData: zt,
    queryFn: () => {
      if ("filterName" in a && a.filterName && a.filterValue)
        return v.browse.getBrowseResults(a.filterName, a.filterValue, y);
      if ("itemIds" in a && a.itemIds)
        return v.browse.getBrowseResultsForItemIds(a.itemIds, y);
    },
    enabled: !!v
  });
}, un = (i, a) => {
  const y = ne.useMemo(() => Je(i), [i]);
  return Vt({
    queryKey: ["cioSearch", a],
    placeholderData: zt,
    queryFn: () => {
      const {
        query: v,
        ..._
      } = a;
      return y.search.getSearchResults(v, _);
    },
    enabled: !!y && !!a.query
  });
}, jr = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
}, cn = (i) => {
  const [a, y] = ne.useState(typeof window < "u" ? window.matchMedia(`(min-width: ${jr[i]})`).matches : !0);
  return ne.useEffect(() => {
    const v = window.matchMedia(`(min-width: ${jr[i]})`);
    y(v.matches);
    const _ = (h) => y(h.matches);
    return v.addEventListener("change", _), () => v.removeEventListener("change", _);
  }, [i]), a;
}, Xi = Wr("inline-flex items-center justify-center gap-2 whitespace-nowrap font-semibold border", {
  variants: {
    variant: {
      default: "bg-accent text-primary border-tertiary",
      destructive: "bg-error text-white border-error",
      warn: "bg-warn text-tertiary border-warn",
      outline: "bg-white text-primary"
    },
    size: {
      default: "py-1.5 px-3 text-sm",
      xs: "py-0.5 px-1.5 text-xs tracking-wider",
      sm: "py-1 px-2 text-xs",
      lg: "p-4 text-lg"
    },
    rounded: {
      none: "",
      pill: "rounded-full",
      sm: "rounded-sm",
      default: "rounded",
      md: "rounded-md",
      lg: "rounded-lg"
    },
    hoverable: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    variant: "default",
    hoverable: !0,
    className: "hover:bg-accent/70"
  }, {
    variant: "destructive",
    hoverable: !0,
    className: "hover:bg-error/70"
  }, {
    variant: "warn",
    hoverable: !0,
    className: "hover:bg-warn/70"
  }],
  defaultVariants: {
    variant: "default",
    size: "default",
    rounded: "default",
    hoverable: !1
  }
});
function Yi({
  children: i,
  className: a,
  variant: y,
  size: v,
  rounded: _,
  hoverable: h,
  onRemove: u
}) {
  const g = u ? "button" : "span";
  return /* @__PURE__ */ X.jsxs(g, {
    className: Ce(Xi({
      variant: y,
      size: v,
      rounded: _,
      hoverable: h ?? !!u,
      className: a
    })),
    onClick: u,
    children: [i, u && /* @__PURE__ */ X.jsx(Xr, {
      className: "size-4 stroke-3 opacity-75"
    })]
  });
}
const Br = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), Mt = (i, a, y) => {
  if (!i)
    return i || "";
  const _ = new URL(i.includes("http") ? i : `https://${i}`).pathname.split(".").pop();
  return _ ? i.replace(`.${_}`, `_${a}x${y || ""}.${_}`) : i;
};
function Zi({
  src: i,
  className: a,
  alt: y,
  width: v,
  height: _,
  aspectRatio: h,
  loading: u = "lazy",
  fetchPriority: g = "auto",
  srcSet: s,
  widths: R = [180, 480, 900, 1400, 1800, 2400, 3600, 4734]
}) {
  return /* @__PURE__ */ X.jsx("img", {
    src: i,
    alt: y,
    srcSet: s || R?.map((E) => {
      let m = i, x = 180;
      return typeof E == "number" ? (x = E, m = Mt(i, E, h ? h * E : E)) : (x = E[0], m = Mt(i, E[0], E[1])), `${m} ${x}w`;
    })?.join(", "),
    width: v,
    height: _,
    loading: u,
    fetchPriority: g,
    sizes: "(min-width: 1400px) calc(100vw / 3), (min-width: 750px) calc(100vw / 3), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)",
    className: a
  });
}
const $i = (i) => {
  const a = {
    "data-cnstrc-item-id": i.id,
    "data-cnstrc-item-name": i.name
  };
  return i.price && (a["data-cnstrc-item-price"] = i.price.toString()), i.variation_id && (a["data-cnstrc-item-variation-id"] = i.variation_id), a;
};
function ln({
  data: i,
  lazyLoadImage: a = !0,
  onClick: y,
  showMfg: v,
  showRating: _,
  showQtyLeftThreshold: h,
  css: u = {},
  imageCount: g = 2
}) {
  const {
    id: s,
    name: R = "",
    price: E,
    url: m,
    images: x = [],
    on_sale: C,
    compareAtPrice: q,
    manufacturer: p,
    rating: e = 0,
    rating_count: t = 0,
    is_sponsored: w = !1,
    inventoryQuantity: n
  } = i;
  let f = C ?? !1;
  const S = Number(q) ?? 0, l = Math.round(e * 2) / 2;
  f && S > 0 && E && E > 0 && S <= E && (f = !1);
  const o = R.replace(/\\/g, ""), r = $i(i);
  return /* @__PURE__ */ X.jsxs("div", {
    className: Ce("md:p-3", u.root),
    ...r,
    children: [/* @__PURE__ */ X.jsx("a", {
      className: Ce("flex justify-center items-center group relative", u.imageWrapper),
      href: m,
      onClick: (d) => y?.(d, i),
      children: x.slice(0, g).map((d, c) => /* @__PURE__ */ X.jsx(Zi, {
        src: d,
        alt: o,
        width: 360,
        height: 360,
        className: Ce("w-full h-full object-contain", x.length > 1 ? c === 0 ? "group-hover:hidden" : "hidden group-hover:block" : void 0),
        loading: a ? "lazy" : "eager",
        fetchPriority: a ? "auto" : "high",
        srcSet: [[360, 480], [720, 900]].map(([b, k]) => `${Mt(d, b, b)} ${k}w`).join(", ")
      }))
    }), /* @__PURE__ */ X.jsxs("div", {
      className: Ce("flex flex-col gap-2 mt-1.5", u.contentWrapper),
      children: [/* @__PURE__ */ X.jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ X.jsx("a", {
          className: "hover:underline leading- line-clamp-3 text-black max-h-[4.5rem] leading-snug",
          href: m,
          onClick: (d) => y?.(d, i),
          children: o
        }), v && p && /* @__PURE__ */ X.jsxs("span", {
          className: "text-mutedAlt font-light text-sm",
          children: ["by ", p]
        }), _ === "yotpo" ? /* @__PURE__ */ X.jsx("div", {
          className: "yotpo-widget-instance h-5 *:!m-0 [&_span]:!h-5 [&_p]:!text-sm [&_p]:!p-0 [&_p]:!no-underline",
          "data-yotpo-instance-id": "1194434",
          "data-yotpo-product-id": s,
          "data-yotpo-section-id": "index"
        }) : _ === "metafield" && e > 0 && /* @__PURE__ */ X.jsxs("div", {
          className: "flex items-end gap-1",
          children: [Array.from({
            length: Math.floor(l)
          }).map((d, c) => /* @__PURE__ */ X.jsx(er, {
            className: "size-5 stroke-0 fill-yellow-400"
          }, c)), l % 1 !== 0 && /* @__PURE__ */ X.jsx(yi, {
            className: "size-5 stroke-0 fill-yellow-400"
          }), Array.from({
            length: (l % 1 !== 0 ? 4 : 5) - Math.floor(l)
          }).map((d, c) => /* @__PURE__ */ X.jsx(er, {
            className: "size-5 stroke-1 text-yellow-400"
          }, c)), t && /* @__PURE__ */ X.jsxs("span", {
            className: "text-sm leading-none",
            children: ["(", /* @__PURE__ */ X.jsx("u", {
              children: t
            }), ")"]
          })]
        })]
      }), /* @__PURE__ */ X.jsxs("div", {
        className: "flex flex-col gap-1 items-start mt-1 md:mt-2",
        children: [f && /* @__PURE__ */ X.jsx(Yi, {
          variant: "destructive",
          size: "xs",
          children: "SALE"
        }), /* @__PURE__ */ X.jsxs("div", {
          className: "flex gap-1.5 items-end",
          children: [E && E > 0 && /* @__PURE__ */ X.jsx("span", {
            className: Ce("font-semibold leading-none", u.price),
            children: Br.format(E).replace(".00", "")
          }), f && E && S > 0 && S > E && /* @__PURE__ */ X.jsx("s", {
            className: "text-sm text-muted leading-tight",
            children: Br.format(S).replace(".00", "")
          })]
        })]
      }), E && E >= 49 && /* @__PURE__ */ X.jsx("p", {
        className: "text-sm mt-1",
        children: "Free Shipping"
      }), h && n && n <= h && /* @__PURE__ */ X.jsxs("span", {
        className: "text-sm text-errorForeground mt-0.5",
        children: ["Only ", n, " Left!"]
      }), w && /* @__PURE__ */ X.jsx("div", {
        className: "text-xs text-mutedAlt",
        children: "Sponsored"
      })]
    })]
  });
}
function fn(i) {
  const a = ne.useMemo(() => Je(i), [i]), y = ne.useCallback((h, u, g) => {
    const {
      name: s,
      id: R,
      variation_id: E
    } = h;
    a.tracker.trackRecommendationClick({
      variationId: E,
      resultId: g.result_id,
      resultCount: g.response?.total_num_results || 0,
      resultPositionOnPage: u + 1,
      podId: g.pod_id,
      strategyId: "complimentary",
      itemId: R,
      itemName: s
    });
  }, [a]), v = ne.useCallback((h, u, g) => {
    const {
      name: s,
      id: R,
      variation_id: E
    } = h;
    a.tracker.trackSearchResultClick(g.query, {
      itemId: R,
      itemName: s,
      variationId: E,
      section: u.section,
      resultId: g.result_id
    });
  }, [a]), _ = ne.useCallback((h, u, g, s) => {
    if (!s.filterName && !s.filterValue)
      return;
    const {
      id: R,
      variation_id: E
    } = h;
    a.tracker.trackBrowseResultClick({
      variationId: E,
      resultId: s.result_id,
      resultCount: s.response?.total_num_results || 0,
      resultPage: g.page,
      resultPositionOnPage: u + 1,
      numResultsPerPage: g.resultsPerPage,
      selectedFilters: g.filters,
      filterName: s.filterName,
      filterValue: s.filterValue,
      itemId: R
    });
  }, [a]);
  return ne.useEffect(() => {
    a && window.__cioSessionStarted !== !0 && (window.__cioSessionStarted = a.tracker.trackSessionStart());
  }, [a]), {
    handleRecommendationsClick: y,
    handleSearchClick: v,
    handleBrowseClick: _
  };
}
export {
  Yi as B,
  Br as C,
  ln as P,
  fn as a,
  an as b,
  Vt as c,
  cn as d,
  sn as e,
  un as u
};
